// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/referral/referral_sales.proto (package guardianai.v1.referral, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/referral/referral_sales.proto.
 */
export const file_guardianai_v1_referral_referral_sales: GenFile = /*@__PURE__*/
  fileDesc("CitndWFyZGlhbmFpL3YxL3JlZmVycmFsL3JlZmVycmFsX3NhbGVzLnByb3RvEhZndWFyZGlhbmFpLnYxLnJlZmVycmFsIugFChBTYWxlc1Bvb2xQcm9kdWN0EgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSDAoEc2x1ZxgDIAEoCRIZChFzaG9ydF9kZXNjcmlwdGlvbhgEIAEoCRIQCghjYXRlZ29yeRgFIAEoCRIMCgR0YWdzGAYgAygJEhkKEXRhcmdldF91c2VyX3R5cGVzGAcgAygJEhkKEXVzZXJfc3Rvcmllc19qc29uGAggASgJEhMKC3BhaW5fcG9pbnRzGAkgAygJEg0KBWdhaW5zGAogAygJEiMKG2NvbXBldGl0aXZlX2RpZmZlcmVudGlhdG9ycxgLIAMoCRIZCgxwcmljaW5nX2luZm8YDCABKAlIAIgBARIYCgtwcmljZV9jZW50cxgNIAEoA0gBiAEBEhQKDGlzX3JlY3VycmluZxgOIAEoCBIXCg9jb21taXNzaW9uX3JhdGUYDyABKAESIwobaWRlYWxfY3VzdG9tZXJfcHJvZmlsZV9qc29uGBAgASgJEh8KF29iamVjdGlvbl9oYW5kbGluZ19qc29uGBEgASgJEhkKEXN1cHBvcnRpbmdfYXNzZXRzGBIgAygJEiAKE3N0cmlwZV9wYXltZW50X2xpbmsYEyABKAlIAogBARIdChVleHRlcm5hbF9kaXN0cmlidXRpb24YFCABKAgSEQoJaXNfYWN0aXZlGBUgASgIEhoKEmNvbXBsZXRlbmVzc19zY29yZRgWIAEoBRIaChJjcmVhdGVkX2J5X3VzZXJfaWQYFyABKAkSEgoKY3JlYXRlZF9hdBgYIAEoCRISCgp1cGRhdGVkX2F0GBkgASgJEiAKGGNvbW1pc3Npb25fZHVyYXRpb25fZGF5cxgaIAEoBRIeChZjb21taXNzaW9uX29uX3JlbmV3YWxzGBsgASgIQg8KDV9wcmljaW5nX2luZm9CDgoMX3ByaWNlX2NlbnRzQhYKFF9zdHJpcGVfcGF5bWVudF9saW5rIs0GCgpTYWxlc0FnZW50EgoKAmlkGAEgASgJEg8KB3VzZXJfaWQYAiABKAkSFAoHY291bnRyeRgDIAEoCUgAiAEBEhkKDHN0YXRlX3JlZ2lvbhgEIAEoCUgBiAEBEhEKBGNpdHkYBSABKAlIAogBARIkChdwcm9mZXNzaW9uYWxfYmFja2dyb3VuZBgGIAEoCUgDiAEBEhoKEmluZHVzdHJ5X2V4cGVydGlzZRgHIAMoCRIYChBzb2NpYWxfcGxhdGZvcm1zGAggAygJEh0KFW5ldHdvcmtfc3RyZW5ndGhfanNvbhgJIAEoCRIWCg5ob3Vyc19wZXJfd2VlaxgKIAEoBRIgChNjb21tdW5pY2F0aW9uX3N0eWxlGAsgASgJSASIAQESHQoVY29tbXVuaXR5X21lbWJlcnNoaXBzGAwgAygJEg4KBnN0YXR1cxgNIAEoCRIkChdvbmJvYXJkaW5nX2NvbXBsZXRlZF9hdBgOIAEoCUgFiAEBEh4KFmF1dGhvcml6ZWRfcHJvZHVjdF9pZHMYDyADKAkSFwoPZGFpbHlfbGxtX3F1b3RhGBAgASgFEhcKD2xsbV9jYWxsc190b2RheRgRIAEoBRIaChJsbG1fcXVvdGFfcmVzZXRfYXQYEiABKAkSHAoUdG90YWxfZWFybmluZ3NfY2VudHMYEyABKAMSGgoSdG90YWxfY2xvc2VkX2RlYWxzGBQgASgFEh8KEmludml0ZWRfYnlfdXNlcl9pZBgVIAEoCUgGiAEBEhIKCmNyZWF0ZWRfYXQYFiABKAkSEgoKdXBkYXRlZF9hdBgXIAEoCRIXCgp1c2VyX2VtYWlsGBggASgJSAeIAQESGwoOdXNlcl9mdWxsX25hbWUYGSABKAlICIgBAUIKCghfY291bnRyeUIPCg1fc3RhdGVfcmVnaW9uQgcKBV9jaXR5QhoKGF9wcm9mZXNzaW9uYWxfYmFja2dyb3VuZEIWChRfY29tbXVuaWNhdGlvbl9zdHlsZUIaChhfb25ib2FyZGluZ19jb21wbGV0ZWRfYXRCFQoTX2ludml0ZWRfYnlfdXNlcl9pZEINCgtfdXNlcl9lbWFpbEIRCg9fdXNlcl9mdWxsX25hbWUi1wEKE1NhbGVzU2VhcmNoU3RyYXRlZ3kSCgoCaWQYASABKAkSFgoOc2FsZXNfYWdlbnRfaWQYAiABKAkSEgoKcHJvZHVjdF9pZBgDIAEoCRIQCghwbGF0Zm9ybRgEIAEoCRIbChNzZWFyY2hfcXVlcmllc19qc29uGAUgASgJEhwKFHRhcmdldF9wZXJzb25hc19qc29uGAYgASgJEhQKDGdlbmVyYXRlZF9hdBgHIAEoCRIRCglsbG1fbW9kZWwYCCABKAkSEgoKY3JlYXRlZF9hdBgJIAEoCSLHBQoJU2FsZXNMZWFkEgoKAmlkGAEgASgJEhYKDnNhbGVzX2FnZW50X2lkGAIgASgJEhIKCnByb2R1Y3RfaWQYAyABKAkSDAoEbmFtZRgEIAEoCRIQCghwbGF0Zm9ybRgFIAEoCRIZCgxwcm9maWxlX2xpbmsYBiABKAlIAIgBARIUCgdjb21wYW55GAcgASgJSAGIAQESFwoKdGl0bGVfcm9sZRgIIAEoCUgCiAEBEhcKD3JlbGV2YW5jZV9zY29yZRgJIAEoBRISCgVub3RlcxgKIAEoCUgDiAEBEg4KBnN0YXR1cxgLIAEoCRIZChFzdGF0dXNfdXBkYXRlZF9hdBgMIAEoCRIeChFuZXh0X2ZvbGxvd191cF9hdBgNIAEoCUgEiAEBEh8KEmxhc3RfcmVzcG9uc2VfdHlwZRgOIAEoCUgFiAEBEh0KEGxhc3RfcmVzcG9uc2VfYXQYDyABKAlIBogBARIYCgtzdHJhdGVneV9pZBgQIAEoCUgHiAEBEiQKF2N1cnJlbnRfbWVzc2FnZV9ub2RlX2lkGBEgASgJSAiIAQESEgoKY3JlYXRlZF9hdBgSIAEoCRISCgp1cGRhdGVkX2F0GBMgASgJEhsKE2NvbXBhbnlfZGVzY3JpcHRpb24YFCABKAkSFwoPY3VycmVudF9wcm9qZWN0GBUgASgJEh4KFmFkZGl0aW9uYWxfcHJvZHVjdF9pZHMYFiADKAlCDwoNX3Byb2ZpbGVfbGlua0IKCghfY29tcGFueUINCgtfdGl0bGVfcm9sZUIICgZfbm90ZXNCFAoSX25leHRfZm9sbG93X3VwX2F0QhUKE19sYXN0X3Jlc3BvbnNlX3R5cGVCEwoRX2xhc3RfcmVzcG9uc2VfYXRCDgoMX3N0cmF0ZWd5X2lkQhoKGF9jdXJyZW50X21lc3NhZ2Vfbm9kZV9pZCLtAgoSU2FsZXNMZWFkVGFibGVUYXNrEgoKAmlkGAEgASgJEhYKDnNhbGVzX2FnZW50X2lkGAIgASgJEhIKCnByb2R1Y3RfaWQYAyABKAkSEAoIcGxhdGZvcm0YBCABKAkSGgoSbWluX2xlYWRzX3JlcXVpcmVkGAUgASgFEhoKEmN1cnJlbnRfbGVhZF9jb3VudBgGIAEoBRITCgtpc19jb21wbGV0ZRgHIAEoCBIeChZzdWJtaXR0ZWRfZm9yX3N0cmF0ZWd5GAggASgIEhkKDHN1Ym1pdHRlZF9hdBgJIAEoCUgAiAEBEhYKDnN0cmF0ZWd5X3JlYWR5GAogASgIEh4KEXN0cmF0ZWd5X3JlYWR5X2F0GAsgASgJSAGIAQESEgoKY3JlYXRlZF9hdBgMIAEoCRISCgp1cGRhdGVkX2F0GA0gASgJQg8KDV9zdWJtaXR0ZWRfYXRCFAoSX3N0cmF0ZWd5X3JlYWR5X2F0Iu0BChRTYWxlc01lc3NhZ2VTdHJhdGVneRIKCgJpZBgBIAEoCRIaChJsZWFkX3RhYmxlX3Rhc2tfaWQYAiABKAkSFgoOc2FsZXNfYWdlbnRfaWQYAyABKAkSGgoSc3RyYXRlZ3lfZGF0YV9qc29uGAQgASgJEhEKCWxsbV9tb2RlbBgFIAEoCRIUCgxnZW5lcmF0ZWRfYXQYBiABKAkSDgoGc3RhdHVzGAcgASgJEhoKDWVycm9yX21lc3NhZ2UYCCABKAlIAIgBARISCgpjcmVhdGVkX2F0GAkgASgJQhAKDl9lcnJvcl9tZXNzYWdlIpQCChFTYWxlc05vdGlmaWNhdGlvbhIKCgJpZBgBIAEoCRIWCg5zYWxlc19hZ2VudF9pZBgCIAEoCRIZChFub3RpZmljYXRpb25fdHlwZRgDIAEoCRINCgV0aXRsZRgEIAEoCRIMCgRib2R5GAUgASgJEhEKBGxpbmsYBiABKAlIAIgBARIUCgdsZWFkX2lkGAcgASgJSAGIAQESDwoHaXNfcmVhZBgIIAEoCBISCgppc19lbWFpbGVkGAkgASgIEhoKDXNjaGVkdWxlZF9mb3IYCiABKAlIAogBARISCgpjcmVhdGVkX2F0GAsgASgJQgcKBV9saW5rQgoKCF9sZWFkX2lkQhAKDl9zY2hlZHVsZWRfZm9yIuwFChNSZWZlcnJhbEF0dHJpYnV0aW9uEgoKAmlkGAEgASgJEhYKDnNhbGVzX2FnZW50X2lkGAIgASgJEhoKDXNhbGVzX2xlYWRfaWQYAyABKAlIAIgBARISCgpwcm9kdWN0X2lkGAQgASgJEhUKDWN1c3RvbWVyX25hbWUYBSABKAkSGwoOY3VzdG9tZXJfZW1haWwYBiABKAlIAYgBARIdChBjdXN0b21lcl9jb21wYW55GAcgASgJSAKIAQESJQoYYXR0cmlidXRlZF9yZXZlbnVlX2NlbnRzGAggASgDSAOIAQESHQoQY29tbWlzc2lvbl9jZW50cxgJIAEoA0gEiAEBEiAKGGNvbW1pc3Npb25fcmF0ZV9zbmFwc2hvdBgKIAEoARIOCgZzdGF0dXMYCyABKAkSIAoTdmVyaWZpZWRfYnlfdXNlcl9pZBgMIAEoCUgFiAEBEhgKC3ZlcmlmaWVkX2F0GA0gASgJSAaIAQESFAoHcGFpZF9hdBgOIAEoCUgHiAEBEhgKC2FkbWluX25vdGVzGA8gASgJSAiIAQESEgoKY3JlYXRlZF9hdBgQIAEoCRISCgp1cGRhdGVkX2F0GBEgASgJEhoKDXJlZmVycmFsX2NvZGUYEiABKAlICYgBARIeChFyZWZlcnJhbF9hZ2VudF9pZBgTIAEoCUgKiAEBEg4KBnNvdXJjZRgUIAEoCUIQCg5fc2FsZXNfbGVhZF9pZEIRCg9fY3VzdG9tZXJfZW1haWxCEwoRX2N1c3RvbWVyX2NvbXBhbnlCGwoZX2F0dHJpYnV0ZWRfcmV2ZW51ZV9jZW50c0ITChFfY29tbWlzc2lvbl9jZW50c0IWChRfdmVyaWZpZWRfYnlfdXNlcl9pZEIOCgxfdmVyaWZpZWRfYXRCCgoIX3BhaWRfYXRCDgoMX2FkbWluX25vdGVzQhAKDl9yZWZlcnJhbF9jb2RlQhQKEl9yZWZlcnJhbF9hZ2VudF9pZCKDAwoMUmVmZXJyYWxMaW5rEgoKAmlkGAEgASgJEhYKDnNhbGVzX2FnZW50X2lkGAIgASgJEhIKCnByb2R1Y3RfaWQYAyABKAkSFAoMcHJvZHVjdF9uYW1lGAQgASgJEhUKDXJlZmVycmFsX2NvZGUYBSABKAkSFAoMY2hlY2tvdXRfdXJsGAYgASgJEhsKE2lzX2V4dGVybmFsX3Byb2R1Y3QYByABKAgSFAoMdG90YWxfY2xpY2tzGAggASgFEhkKEXRvdGFsX2NvbnZlcnNpb25zGAkgASgFEhsKE3RvdGFsX3JldmVudWVfY2VudHMYCiABKAMSHgoWdG90YWxfY29tbWlzc2lvbl9jZW50cxgLIAEoAxIXCg9jb21taXNzaW9uX3JhdGUYDCABKAESIAoYY29tbWlzc2lvbl9kdXJhdGlvbl9kYXlzGA0gASgFEh4KFmNvbW1pc3Npb25fb25fcmVuZXdhbHMYDiABKAgSEgoKY3JlYXRlZF9hdBgPIAEoCSJGChVTYWxlc09uYm9hcmRpbmdDb25maWcSGQoReW91dHViZV92aWRlb191cmwYASABKAkSEgoKdXBkYXRlZF9hdBgCIAEoCSKmBAoTUHJvZHVjdENhdGFsb2dFbnRyeRIKCgJpZBgBIAEoCRIVCg1mcm9udGVuZF9zbHVnGAIgASgJEgwKBG5hbWUYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSEAoIY2F0ZWdvcnkYBSABKAkSHAoUYmFzZV9jb21taXNzaW9uX3JhdGUYBiABKAESHgoWaXNfYXZhaWxhYmxlX2Zvcl9zYWxlcxgHIAEoCBISCgpjcmVhdGVkX2F0GAggASgJEhYKCWltYWdlX3VybBgJIAEoCUgAiAEBEhUKDW1ldGFkYXRhX2pzb24YCiABKAkSHAoUc3RydWN0dXJlZF9kYXRhX2pzb24YCyABKAkSDAoEdGFncxgMIAMoCRIQCghmZWF0dXJlcxgNIAMoCRIaCg1wcmljZV9kaXNwbGF5GA4gASgJSAGIAQESGwoOcGVyaW9kX2Rpc3BsYXkYDyABKAlIAogBARIXCgpzdHJpcGVfdXJsGBAgASgJSAOIAQESHQoQY29udGFjdF9jYXRlZ29yeRgRIAEoCUgEiAEBEhwKD3N0cmlwZV9wcmljZV9pZBgSIAEoCUgFiAEBQgwKCl9pbWFnZV91cmxCEAoOX3ByaWNlX2Rpc3BsYXlCEQoPX3BlcmlvZF9kaXNwbGF5Qg0KC19zdHJpcGVfdXJsQhMKEV9jb250YWN0X2NhdGVnb3J5QhIKEF9zdHJpcGVfcHJpY2VfaWQiOAoZTGlzdFByb2R1Y3RDYXRhbG9nUmVxdWVzdBIMCgRwYWdlGAEgASgFEg0KBWxpbWl0GAIgASgFInAKGkxpc3RQcm9kdWN0Q2F0YWxvZ1Jlc3BvbnNlEj0KCHByb2R1Y3RzGAEgAygLMisuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5Qcm9kdWN0Q2F0YWxvZ0VudHJ5EhMKC3RvdGFsX2NvdW50GAIgASgFIlsKG0NyZWF0ZVByb2R1Y3RDYXRhbG9nUmVxdWVzdBI8Cgdwcm9kdWN0GAEgASgLMisuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5Qcm9kdWN0Q2F0YWxvZ0VudHJ5IlsKG1VwZGF0ZVByb2R1Y3RDYXRhbG9nUmVxdWVzdBI8Cgdwcm9kdWN0GAEgASgLMisuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5Qcm9kdWN0Q2F0YWxvZ0VudHJ5IikKG0RlbGV0ZVByb2R1Y3RDYXRhbG9nUmVxdWVzdBIKCgJpZBgBIAEoCSIvChxEZWxldGVQcm9kdWN0Q2F0YWxvZ1Jlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgiUQoUQ3JlYXRlUHJvZHVjdFJlcXVlc3QSOQoHcHJvZHVjdBgBIAEoCzIoLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNQb29sUHJvZHVjdCJRChRVcGRhdGVQcm9kdWN0UmVxdWVzdBI5Cgdwcm9kdWN0GAEgASgLMiguZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc1Bvb2xQcm9kdWN0IiIKFERlbGV0ZVByb2R1Y3RSZXF1ZXN0EgoKAmlkGAEgASgJIigKFURlbGV0ZVByb2R1Y3RSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIIlgKE0xpc3RQcm9kdWN0c1JlcXVlc3QSFgoJaXNfYWN0aXZlGAEgASgISACIAQESDAoEcGFnZRgCIAEoBRINCgVsaW1pdBgDIAEoBUIMCgpfaXNfYWN0aXZlImcKFExpc3RQcm9kdWN0c1Jlc3BvbnNlEjoKCHByb2R1Y3RzGAEgAygLMiguZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc1Bvb2xQcm9kdWN0EhMKC3RvdGFsX2NvdW50GAIgASgFIh8KEUdldFByb2R1Y3RSZXF1ZXN0EgoKAmlkGAEgASgJIkwKD1Byb2R1Y3RSZXNwb25zZRI5Cgdwcm9kdWN0GAEgASgLMiguZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc1Bvb2xQcm9kdWN0IkgKF0ludml0ZVNhbGVzQWdlbnRSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEh4KFmF1dGhvcml6ZWRfcHJvZHVjdF9pZHMYAiADKAkiQgoYSW52aXRlU2FsZXNBZ2VudFJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgSFQoNbWFnaWNfbGlua19pZBgCIAEoCSJVChZMaXN0U2FsZXNBZ2VudHNSZXF1ZXN0EhMKBnN0YXR1cxgBIAEoCUgAiAEBEgwKBHBhZ2UYAiABKAUSDQoFbGltaXQYAyABKAVCCQoHX3N0YXR1cyJiChdMaXN0U2FsZXNBZ2VudHNSZXNwb25zZRIyCgZhZ2VudHMYASADKAsyIi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzQWdlbnQSEwoLdG90YWxfY291bnQYAiABKAUiIgoUR2V0U2FsZXNBZ2VudFJlcXVlc3QSCgoCaWQYASABKAkiJgoYU3VzcGVuZFNhbGVzQWdlbnRSZXF1ZXN0EgoKAmlkGAEgASgJIksKHVVwZGF0ZUFnZW50UHJvZHVjdEF1dGhSZXF1ZXN0EgoKAmlkGAEgASgJEh4KFmF1dGhvcml6ZWRfcHJvZHVjdF9pZHMYAiADKAkiRwoSU2FsZXNBZ2VudFJlc3BvbnNlEjEKBWFnZW50GAEgASgLMiIuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc0FnZW50IoYBChdMaXN0QXR0cmlidXRpb25zUmVxdWVzdBIbCg5zYWxlc19hZ2VudF9pZBgBIAEoCUgAiAEBEhMKBnN0YXR1cxgCIAEoCUgBiAEBEgwKBHBhZ2UYAyABKAUSDQoFbGltaXQYBCABKAVCEQoPX3NhbGVzX2FnZW50X2lkQgkKB19zdGF0dXMicgoYTGlzdEF0dHJpYnV0aW9uc1Jlc3BvbnNlEkEKDGF0dHJpYnV0aW9ucxgBIAMoCzIrLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUmVmZXJyYWxBdHRyaWJ1dGlvbhITCgt0b3RhbF9jb3VudBgCIAEoBSI9ChhWZXJpZnlBdHRyaWJ1dGlvblJlcXVlc3QSCgoCaWQYASABKAkSFQoNcmV2ZW51ZV9jZW50cxgCIAEoAyI1ChhSZWplY3RBdHRyaWJ1dGlvblJlcXVlc3QSCgoCaWQYASABKAkSDQoFbm90ZXMYAiABKAkiKAoaTWFya0F0dHJpYnV0aW9uUGFpZFJlcXVlc3QSCgoCaWQYASABKAkiVwoTQXR0cmlidXRpb25SZXNwb25zZRJACgthdHRyaWJ1dGlvbhgBIAEoCzIrLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUmVmZXJyYWxBdHRyaWJ1dGlvbiIiCiBHZXRSZWZlcnJhbERhc2hib2FyZFN0YXRzUmVxdWVzdCLFAQoeUmVmZXJyYWxEYXNoYm9hcmRTdGF0c1Jlc3BvbnNlEhQKDHRvdGFsX2FnZW50cxgBIAEoBRIVCg1hY3RpdmVfYWdlbnRzGAIgASgFEhMKC3RvdGFsX2xlYWRzGAMgASgFEhQKDGNsb3NlZF9kZWFscxgEIAEoBRIjCht0b3RhbF9jb21taXNzaW9uX3BhaWRfY2VudHMYBSABKAMSJgoedG90YWxfY29tbWlzc2lvbl9wZW5kaW5nX2NlbnRzGAYgASgDIiEKH0dldFNhbGVzT25ib2FyZGluZ0NvbmZpZ1JlcXVlc3QiPwoiVXBkYXRlU2FsZXNPbmJvYXJkaW5nQ29uZmlnUmVxdWVzdBIZChF5b3V0dWJlX3ZpZGVvX3VybBgBIAEoCSJeCh1TYWxlc09uYm9hcmRpbmdDb25maWdSZXNwb25zZRI9CgZjb25maWcYASABKAsyLS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzT25ib2FyZGluZ0NvbmZpZyImChhBcHByb3ZlU2FsZXNBZ2VudFJlcXVlc3QSCgoCaWQYASABKAkiHQobR2V0T25ib2FyZGluZ1Byb2ZpbGVSZXF1ZXN0IpUBChlPbmJvYXJkaW5nUHJvZmlsZVJlc3BvbnNlEjEKBWFnZW50GAEgASgLMiIuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc0FnZW50EkUKE2F1dGhvcml6ZWRfcHJvZHVjdHMYAiADKAsyKC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzUG9vbFByb2R1Y3QiWwoeU3VibWl0T25ib2FyZGluZ1Byb2ZpbGVSZXF1ZXN0EjkKDWFnZW50X3Byb2ZpbGUYASABKAsyIi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzQWdlbnQiMgofU3VibWl0T25ib2FyZGluZ1Byb2ZpbGVSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIIkQKGkdldFNlYXJjaFN0cmF0ZWdpZXNSZXF1ZXN0EhcKCnByb2R1Y3RfaWQYASABKAlIAIgBAUINCgtfcHJvZHVjdF9pZCJeChtHZXRTZWFyY2hTdHJhdGVnaWVzUmVzcG9uc2USPwoKc3RyYXRlZ2llcxgBIAMoCzIrLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNTZWFyY2hTdHJhdGVneSI3CiFSZWdlbmVyYXRlU2VhcmNoU3RyYXRlZ2llc1JlcXVlc3QSEgoKcHJvZHVjdF9pZBgBIAEoCSJlCiJSZWdlbmVyYXRlU2VhcmNoU3RyYXRlZ2llc1Jlc3BvbnNlEj8KCnN0cmF0ZWdpZXMYASADKAsyKy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzU2VhcmNoU3RyYXRlZ3kiLAoZR2V0TWVzc2FnZVN0cmF0ZWd5UmVxdWVzdBIPCgd0YXNrX2lkGAEgASgJIlwKGkdldE1lc3NhZ2VTdHJhdGVneVJlc3BvbnNlEj4KCHN0cmF0ZWd5GAEgASgLMiwuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc01lc3NhZ2VTdHJhdGVneSJEChFDcmVhdGVMZWFkUmVxdWVzdBIvCgRsZWFkGAEgASgLMiEuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc0xlYWQiRAoRVXBkYXRlTGVhZFJlcXVlc3QSLwoEbGVhZBgBIAEoCzIhLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNMZWFkIh8KEURlbGV0ZUxlYWRSZXF1ZXN0EgoKAmlkGAEgASgJIiUKEkRlbGV0ZUxlYWRSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIIpsBChBMaXN0TGVhZHNSZXF1ZXN0EhcKCnByb2R1Y3RfaWQYASABKAlIAIgBARIVCghwbGF0Zm9ybRgCIAEoCUgBiAEBEhMKBnN0YXR1cxgDIAEoCUgCiAEBEgwKBHBhZ2UYBCABKAUSDQoFbGltaXQYBSABKAVCDQoLX3Byb2R1Y3RfaWRCCwoJX3BsYXRmb3JtQgkKB19zdGF0dXMiWgoRTGlzdExlYWRzUmVzcG9uc2USMAoFbGVhZHMYASADKAsyIS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzTGVhZBITCgt0b3RhbF9jb3VudBgCIAEoBSIcCg5HZXRMZWFkUmVxdWVzdBIKCgJpZBgBIAEoCSJnChdVcGRhdGVMZWFkU3RhdHVzUmVxdWVzdBIKCgJpZBgBIAEoCRISCgpuZXdfc3RhdHVzGAIgASgJEhoKDXJlc3BvbnNlX3R5cGUYAyABKAlIAIgBAUIQCg5fcmVzcG9uc2VfdHlwZSI/CgxMZWFkUmVzcG9uc2USLwoEbGVhZBgBIAEoCzIhLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNMZWFkIhoKGEdldExlYWRUYWJsZVRhc2tzUmVxdWVzdCJWChlHZXRMZWFkVGFibGVUYXNrc1Jlc3BvbnNlEjkKBXRhc2tzGAEgAygLMiouZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc0xlYWRUYWJsZVRhc2siKwoYU3VibWl0Rm9yU3RyYXRlZ3lSZXF1ZXN0Eg8KB3Rhc2tfaWQYASABKAkiLAoZU3VibWl0Rm9yU3RyYXRlZ3lSZXNwb25zZRIPCgdzdWNjZXNzGAEgASgIIkIKHEdldFNhbGVzTm90aWZpY2F0aW9uc1JlcXVlc3QSEwoLdW5yZWFkX29ubHkYASABKAgSDQoFbGltaXQYAiABKAUiYQodR2V0U2FsZXNOb3RpZmljYXRpb25zUmVzcG9uc2USQAoNbm90aWZpY2F0aW9ucxgBIAMoCzIpLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNOb3RpZmljYXRpb24iLgogTWFya1NhbGVzTm90aWZpY2F0aW9uUmVhZFJlcXVlc3QSCgoCaWQYASABKAkiNAohTWFya1NhbGVzTm90aWZpY2F0aW9uUmVhZFJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgiHAoaTGlzdE15UmVmZXJyYWxMaW5rc1JlcXVlc3QiUgobTGlzdE15UmVmZXJyYWxMaW5rc1Jlc3BvbnNlEjMKBWxpbmtzGAEgAygLMiQuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5SZWZlcnJhbExpbmsiMQobR2V0UmVmZXJyYWxMaW5rU3RhdHNSZXF1ZXN0EhIKCnByb2R1Y3RfaWQYASABKAkimAEKGVJlZmVycmFsTGlua1N0YXRzUmVzcG9uc2USMgoEbGluaxgBIAEoCzIkLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUmVmZXJyYWxMaW5rEkcKEnJlY2VudF9jb252ZXJzaW9ucxgCIAMoCzIrLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUmVmZXJyYWxBdHRyaWJ1dGlvbiLAAQoYQ3JlYXRlQXR0cmlidXRpb25SZXF1ZXN0EhUKDXNhbGVzX2xlYWRfaWQYASABKAkSEgoKcHJvZHVjdF9pZBgCIAEoCRIVCg1jdXN0b21lcl9uYW1lGAMgASgJEhsKDmN1c3RvbWVyX2VtYWlsGAQgASgJSACIAQESHQoQY3VzdG9tZXJfY29tcGFueRgFIAEoCUgBiAEBQhEKD19jdXN0b21lcl9lbWFpbEITChFfY3VzdG9tZXJfY29tcGFueSI4ChlMaXN0TXlBdHRyaWJ1dGlvbnNSZXF1ZXN0EgwKBHBhZ2UYASABKAUSDQoFbGltaXQYAiABKAUidAoaTGlzdE15QXR0cmlidXRpb25zUmVzcG9uc2USQQoMYXR0cmlidXRpb25zGAEgAygLMisuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5SZWZlcnJhbEF0dHJpYnV0aW9uEhMKC3RvdGFsX2NvdW50GAIgASgFIhoKGEdldEFnZW50RGFzaGJvYXJkUmVxdWVzdCLtAQoWQWdlbnREYXNoYm9hcmRSZXNwb25zZRIfChdhc3NpZ25lZF9wcm9kdWN0c19jb3VudBgBIAEoBRITCgt0b3RhbF9sZWFkcxgCIAEoBRIWCg5kdWVfZm9sbG93X3VwcxgDIAEoBRIUCgxjbG9zZWRfZGVhbHMYBCABKAUSHAoUdG90YWxfZWFybmluZ3NfY2VudHMYBSABKAMSHgoWcGVuZGluZ19lYXJuaW5nc19jZW50cxgGIAEoAxIxCgVhZ2VudBgHIAEoCzIiLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNBZ2VudCIkChNBcHBseUFzQWdlbnRSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJIicKFEFwcGx5QXNBZ2VudFJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgiIgogR2V0UHVibGljT25ib2FyZGluZ0NvbmZpZ1JlcXVlc3Qy6hQKGUFkbWluUmVmZXJyYWxTYWxlc1NlcnZpY2USZgoNQ3JlYXRlUHJvZHVjdBIsLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuQ3JlYXRlUHJvZHVjdFJlcXVlc3QaJy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlByb2R1Y3RSZXNwb25zZRJmCg1VcGRhdGVQcm9kdWN0EiwuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5VcGRhdGVQcm9kdWN0UmVxdWVzdBonLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUHJvZHVjdFJlc3BvbnNlEmwKDURlbGV0ZVByb2R1Y3QSLC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkRlbGV0ZVByb2R1Y3RSZXF1ZXN0Gi0uZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5EZWxldGVQcm9kdWN0UmVzcG9uc2USaQoMTGlzdFByb2R1Y3RzEisuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MaXN0UHJvZHVjdHNSZXF1ZXN0GiwuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MaXN0UHJvZHVjdHNSZXNwb25zZRJgCgpHZXRQcm9kdWN0EikuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRQcm9kdWN0UmVxdWVzdBonLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUHJvZHVjdFJlc3BvbnNlEnUKEEludml0ZVNhbGVzQWdlbnQSLy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkludml0ZVNhbGVzQWdlbnRSZXF1ZXN0GjAuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5JbnZpdGVTYWxlc0FnZW50UmVzcG9uc2UScgoPTGlzdFNhbGVzQWdlbnRzEi4uZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MaXN0U2FsZXNBZ2VudHNSZXF1ZXN0Gi8uZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MaXN0U2FsZXNBZ2VudHNSZXNwb25zZRJpCg1HZXRTYWxlc0FnZW50EiwuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRTYWxlc0FnZW50UmVxdWVzdBoqLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU2FsZXNBZ2VudFJlc3BvbnNlEnEKEUFwcHJvdmVTYWxlc0FnZW50EjAuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5BcHByb3ZlU2FsZXNBZ2VudFJlcXVlc3QaKi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzQWdlbnRSZXNwb25zZRJxChFTdXNwZW5kU2FsZXNBZ2VudBIwLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU3VzcGVuZFNhbGVzQWdlbnRSZXF1ZXN0GiouZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc0FnZW50UmVzcG9uc2USewoWVXBkYXRlQWdlbnRQcm9kdWN0QXV0aBI1Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuVXBkYXRlQWdlbnRQcm9kdWN0QXV0aFJlcXVlc3QaKi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzQWdlbnRSZXNwb25zZRJ1ChBMaXN0QXR0cmlidXRpb25zEi8uZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MaXN0QXR0cmlidXRpb25zUmVxdWVzdBowLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGlzdEF0dHJpYnV0aW9uc1Jlc3BvbnNlEnIKEVZlcmlmeUF0dHJpYnV0aW9uEjAuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5WZXJpZnlBdHRyaWJ1dGlvblJlcXVlc3QaKy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkF0dHJpYnV0aW9uUmVzcG9uc2UScgoRUmVqZWN0QXR0cmlidXRpb24SMC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlJlamVjdEF0dHJpYnV0aW9uUmVxdWVzdBorLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuQXR0cmlidXRpb25SZXNwb25zZRJ2ChNNYXJrQXR0cmlidXRpb25QYWlkEjIuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5NYXJrQXR0cmlidXRpb25QYWlkUmVxdWVzdBorLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuQXR0cmlidXRpb25SZXNwb25zZRKNAQoZR2V0UmVmZXJyYWxEYXNoYm9hcmRTdGF0cxI4Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuR2V0UmVmZXJyYWxEYXNoYm9hcmRTdGF0c1JlcXVlc3QaNi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlJlZmVycmFsRGFzaGJvYXJkU3RhdHNSZXNwb25zZRKKAQoYR2V0U2FsZXNPbmJvYXJkaW5nQ29uZmlnEjcuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRTYWxlc09uYm9hcmRpbmdDb25maWdSZXF1ZXN0GjUuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc09uYm9hcmRpbmdDb25maWdSZXNwb25zZRKQAQobVXBkYXRlU2FsZXNPbmJvYXJkaW5nQ29uZmlnEjouZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5VcGRhdGVTYWxlc09uYm9hcmRpbmdDb25maWdSZXF1ZXN0GjUuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5TYWxlc09uYm9hcmRpbmdDb25maWdSZXNwb25zZRJ7ChJMaXN0UHJvZHVjdENhdGFsb2cSMS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkxpc3RQcm9kdWN0Q2F0YWxvZ1JlcXVlc3QaMi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkxpc3RQcm9kdWN0Q2F0YWxvZ1Jlc3BvbnNlEn0KGUNyZWF0ZVByb2R1Y3RDYXRhbG9nRW50cnkSMy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkNyZWF0ZVByb2R1Y3RDYXRhbG9nUmVxdWVzdBorLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUHJvZHVjdENhdGFsb2dFbnRyeRJ9ChlVcGRhdGVQcm9kdWN0Q2F0YWxvZ0VudHJ5EjMuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5VcGRhdGVQcm9kdWN0Q2F0YWxvZ1JlcXVlc3QaKy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlByb2R1Y3RDYXRhbG9nRW50cnkShgEKGURlbGV0ZVByb2R1Y3RDYXRhbG9nRW50cnkSMy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkRlbGV0ZVByb2R1Y3RDYXRhbG9nUmVxdWVzdBo0Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuRGVsZXRlUHJvZHVjdENhdGFsb2dSZXNwb25zZTLvEwoRU2FsZXNBZ2VudFNlcnZpY2USfgoUR2V0T25ib2FyZGluZ1Byb2ZpbGUSMy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldE9uYm9hcmRpbmdQcm9maWxlUmVxdWVzdBoxLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuT25ib2FyZGluZ1Byb2ZpbGVSZXNwb25zZRKKAQoXU3VibWl0T25ib2FyZGluZ1Byb2ZpbGUSNi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlN1Ym1pdE9uYm9hcmRpbmdQcm9maWxlUmVxdWVzdBo3Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU3VibWl0T25ib2FyZGluZ1Byb2ZpbGVSZXNwb25zZRJ+ChNHZXRTZWFyY2hTdHJhdGVnaWVzEjIuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRTZWFyY2hTdHJhdGVnaWVzUmVxdWVzdBozLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuR2V0U2VhcmNoU3RyYXRlZ2llc1Jlc3BvbnNlEpMBChpSZWdlbmVyYXRlU2VhcmNoU3RyYXRlZ2llcxI5Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuUmVnZW5lcmF0ZVNlYXJjaFN0cmF0ZWdpZXNSZXF1ZXN0GjouZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5SZWdlbmVyYXRlU2VhcmNoU3RyYXRlZ2llc1Jlc3BvbnNlEl0KCkNyZWF0ZUxlYWQSKS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkNyZWF0ZUxlYWRSZXF1ZXN0GiQuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MZWFkUmVzcG9uc2USXQoKVXBkYXRlTGVhZBIpLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuVXBkYXRlTGVhZFJlcXVlc3QaJC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkxlYWRSZXNwb25zZRJjCgpEZWxldGVMZWFkEikuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5EZWxldGVMZWFkUmVxdWVzdBoqLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuRGVsZXRlTGVhZFJlc3BvbnNlEmAKCUxpc3RMZWFkcxIoLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGlzdExlYWRzUmVxdWVzdBopLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGlzdExlYWRzUmVzcG9uc2USVwoHR2V0TGVhZBImLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuR2V0TGVhZFJlcXVlc3QaJC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkxlYWRSZXNwb25zZRJpChBVcGRhdGVMZWFkU3RhdHVzEi8uZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5VcGRhdGVMZWFkU3RhdHVzUmVxdWVzdBokLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGVhZFJlc3BvbnNlEngKEUdldExlYWRUYWJsZVRhc2tzEjAuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRMZWFkVGFibGVUYXNrc1JlcXVlc3QaMS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldExlYWRUYWJsZVRhc2tzUmVzcG9uc2USeAoRU3VibWl0Rm9yU3RyYXRlZ3kSMC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlN1Ym1pdEZvclN0cmF0ZWd5UmVxdWVzdBoxLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuU3VibWl0Rm9yU3RyYXRlZ3lSZXNwb25zZRJ7ChJHZXRNZXNzYWdlU3RyYXRlZ3kSMS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldE1lc3NhZ2VTdHJhdGVneVJlcXVlc3QaMi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldE1lc3NhZ2VTdHJhdGVneVJlc3BvbnNlEn8KEEdldE5vdGlmaWNhdGlvbnMSNC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldFNhbGVzTm90aWZpY2F0aW9uc1JlcXVlc3QaNS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldFNhbGVzTm90aWZpY2F0aW9uc1Jlc3BvbnNlEosBChRNYXJrTm90aWZpY2F0aW9uUmVhZBI4Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTWFya1NhbGVzTm90aWZpY2F0aW9uUmVhZFJlcXVlc3QaOS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLk1hcmtTYWxlc05vdGlmaWNhdGlvblJlYWRSZXNwb25zZRJ+ChNMaXN0TXlSZWZlcnJhbExpbmtzEjIuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5MaXN0TXlSZWZlcnJhbExpbmtzUmVxdWVzdBozLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGlzdE15UmVmZXJyYWxMaW5rc1Jlc3BvbnNlEn4KFEdldFJlZmVycmFsTGlua1N0YXRzEjMuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRSZWZlcnJhbExpbmtTdGF0c1JlcXVlc3QaMS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlJlZmVycmFsTGlua1N0YXRzUmVzcG9uc2UScgoRQ3JlYXRlQXR0cmlidXRpb24SMC5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkNyZWF0ZUF0dHJpYnV0aW9uUmVxdWVzdBorLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuQXR0cmlidXRpb25SZXNwb25zZRJ7ChJMaXN0TXlBdHRyaWJ1dGlvbnMSMS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkxpc3RNeUF0dHJpYnV0aW9uc1JlcXVlc3QaMi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkxpc3RNeUF0dHJpYnV0aW9uc1Jlc3BvbnNlEnUKEUdldEFnZW50RGFzaGJvYXJkEjAuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5HZXRBZ2VudERhc2hib2FyZFJlcXVlc3QaLi5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkFnZW50RGFzaGJvYXJkUmVzcG9uc2UShQEKE0dldE9uYm9hcmRpbmdDb25maWcSNy5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLkdldFNhbGVzT25ib2FyZGluZ0NvbmZpZ1JlcXVlc3QaNS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzT25ib2FyZGluZ0NvbmZpZ1Jlc3BvbnNlMo4DChVQdWJsaWNSZWZlcnJhbFNlcnZpY2USaQoMQXBwbHlBc0FnZW50EisuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5BcHBseUFzQWdlbnRSZXF1ZXN0GiwuZ3VhcmRpYW5haS52MS5yZWZlcnJhbC5BcHBseUFzQWdlbnRSZXNwb25zZRKMAQoZR2V0UHVibGljT25ib2FyZGluZ0NvbmZpZxI4Lmd1YXJkaWFuYWkudjEucmVmZXJyYWwuR2V0UHVibGljT25ib2FyZGluZ0NvbmZpZ1JlcXVlc3QaNS5ndWFyZGlhbmFpLnYxLnJlZmVycmFsLlNhbGVzT25ib2FyZGluZ0NvbmZpZ1Jlc3BvbnNlEnsKEkxpc3RQcm9kdWN0Q2F0YWxvZxIxLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGlzdFByb2R1Y3RDYXRhbG9nUmVxdWVzdBoyLmd1YXJkaWFuYWkudjEucmVmZXJyYWwuTGlzdFByb2R1Y3RDYXRhbG9nUmVzcG9uc2ViBnByb3RvMw");

/**
 * @generated from message guardianai.v1.referral.SalesPoolProduct
 */
export type SalesPoolProduct = Message<"guardianai.v1.referral.SalesPoolProduct"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * @generated from field: string short_description = 4;
   */
  shortDescription: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[];

  /**
   * @generated from field: repeated string target_user_types = 7;
   */
  targetUserTypes: string[];

  /**
   * @generated from field: string user_stories_json = 8;
   */
  userStoriesJson: string;

  /**
   * @generated from field: repeated string pain_points = 9;
   */
  painPoints: string[];

  /**
   * @generated from field: repeated string gains = 10;
   */
  gains: string[];

  /**
   * @generated from field: repeated string competitive_differentiators = 11;
   */
  competitiveDifferentiators: string[];

  /**
   * @generated from field: optional string pricing_info = 12;
   */
  pricingInfo?: string;

  /**
   * @generated from field: optional int64 price_cents = 13;
   */
  priceCents?: bigint;

  /**
   * @generated from field: bool is_recurring = 14;
   */
  isRecurring: boolean;

  /**
   * @generated from field: double commission_rate = 15;
   */
  commissionRate: number;

  /**
   * @generated from field: string ideal_customer_profile_json = 16;
   */
  idealCustomerProfileJson: string;

  /**
   * @generated from field: string objection_handling_json = 17;
   */
  objectionHandlingJson: string;

  /**
   * @generated from field: repeated string supporting_assets = 18;
   */
  supportingAssets: string[];

  /**
   * @generated from field: optional string stripe_payment_link = 19;
   */
  stripePaymentLink?: string;

  /**
   * @generated from field: bool external_distribution = 20;
   */
  externalDistribution: boolean;

  /**
   * @generated from field: bool is_active = 21;
   */
  isActive: boolean;

  /**
   * @generated from field: int32 completeness_score = 22;
   */
  completenessScore: number;

  /**
   * @generated from field: string created_by_user_id = 23;
   */
  createdByUserId: string;

  /**
   * @generated from field: string created_at = 24;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 25;
   */
  updatedAt: string;

  /**
   * Default: 365
   *
   * @generated from field: int32 commission_duration_days = 26;
   */
  commissionDurationDays: number;

  /**
   * Default: true
   *
   * @generated from field: bool commission_on_renewals = 27;
   */
  commissionOnRenewals: boolean;
};

/**
 * @generated from message guardianai.v1.referral.SalesPoolProduct
 */
export type SalesPoolProductJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string slug = 3;
   */
  slug?: string;

  /**
   * @generated from field: string short_description = 4;
   */
  shortDescription?: string;

  /**
   * @generated from field: string category = 5;
   */
  category?: string;

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags?: string[];

  /**
   * @generated from field: repeated string target_user_types = 7;
   */
  targetUserTypes?: string[];

  /**
   * @generated from field: string user_stories_json = 8;
   */
  userStoriesJson?: string;

  /**
   * @generated from field: repeated string pain_points = 9;
   */
  painPoints?: string[];

  /**
   * @generated from field: repeated string gains = 10;
   */
  gains?: string[];

  /**
   * @generated from field: repeated string competitive_differentiators = 11;
   */
  competitiveDifferentiators?: string[];

  /**
   * @generated from field: optional string pricing_info = 12;
   */
  pricingInfo?: string;

  /**
   * @generated from field: optional int64 price_cents = 13;
   */
  priceCents?: string;

  /**
   * @generated from field: bool is_recurring = 14;
   */
  isRecurring?: boolean;

  /**
   * @generated from field: double commission_rate = 15;
   */
  commissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string ideal_customer_profile_json = 16;
   */
  idealCustomerProfileJson?: string;

  /**
   * @generated from field: string objection_handling_json = 17;
   */
  objectionHandlingJson?: string;

  /**
   * @generated from field: repeated string supporting_assets = 18;
   */
  supportingAssets?: string[];

  /**
   * @generated from field: optional string stripe_payment_link = 19;
   */
  stripePaymentLink?: string;

  /**
   * @generated from field: bool external_distribution = 20;
   */
  externalDistribution?: boolean;

  /**
   * @generated from field: bool is_active = 21;
   */
  isActive?: boolean;

  /**
   * @generated from field: int32 completeness_score = 22;
   */
  completenessScore?: number;

  /**
   * @generated from field: string created_by_user_id = 23;
   */
  createdByUserId?: string;

  /**
   * @generated from field: string created_at = 24;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 25;
   */
  updatedAt?: string;

  /**
   * Default: 365
   *
   * @generated from field: int32 commission_duration_days = 26;
   */
  commissionDurationDays?: number;

  /**
   * Default: true
   *
   * @generated from field: bool commission_on_renewals = 27;
   */
  commissionOnRenewals?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.SalesPoolProduct.
 * Use `create(SalesPoolProductSchema)` to create a new message.
 */
export const SalesPoolProductSchema: GenMessage<SalesPoolProduct, {jsonType: SalesPoolProductJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 0);

/**
 * @generated from message guardianai.v1.referral.SalesAgent
 */
export type SalesAgent = Message<"guardianai.v1.referral.SalesAgent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: optional string country = 3;
   */
  country?: string;

  /**
   * @generated from field: optional string state_region = 4;
   */
  stateRegion?: string;

  /**
   * @generated from field: optional string city = 5;
   */
  city?: string;

  /**
   * @generated from field: optional string professional_background = 6;
   */
  professionalBackground?: string;

  /**
   * @generated from field: repeated string industry_expertise = 7;
   */
  industryExpertise: string[];

  /**
   * @generated from field: repeated string social_platforms = 8;
   */
  socialPlatforms: string[];

  /**
   * @generated from field: string network_strength_json = 9;
   */
  networkStrengthJson: string;

  /**
   * @generated from field: int32 hours_per_week = 10;
   */
  hoursPerWeek: number;

  /**
   * @generated from field: optional string communication_style = 11;
   */
  communicationStyle?: string;

  /**
   * @generated from field: repeated string community_memberships = 12;
   */
  communityMemberships: string[];

  /**
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * @generated from field: optional string onboarding_completed_at = 14;
   */
  onboardingCompletedAt?: string;

  /**
   * @generated from field: repeated string authorized_product_ids = 15;
   */
  authorizedProductIds: string[];

  /**
   * @generated from field: int32 daily_llm_quota = 16;
   */
  dailyLlmQuota: number;

  /**
   * @generated from field: int32 llm_calls_today = 17;
   */
  llmCallsToday: number;

  /**
   * @generated from field: string llm_quota_reset_at = 18;
   */
  llmQuotaResetAt: string;

  /**
   * @generated from field: int64 total_earnings_cents = 19;
   */
  totalEarningsCents: bigint;

  /**
   * @generated from field: int32 total_closed_deals = 20;
   */
  totalClosedDeals: number;

  /**
   * @generated from field: optional string invited_by_user_id = 21;
   */
  invitedByUserId?: string;

  /**
   * @generated from field: string created_at = 22;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 23;
   */
  updatedAt: string;

  /**
   * @generated from field: optional string user_email = 24;
   */
  userEmail?: string;

  /**
   * @generated from field: optional string user_full_name = 25;
   */
  userFullName?: string;
};

/**
 * @generated from message guardianai.v1.referral.SalesAgent
 */
export type SalesAgentJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: optional string country = 3;
   */
  country?: string;

  /**
   * @generated from field: optional string state_region = 4;
   */
  stateRegion?: string;

  /**
   * @generated from field: optional string city = 5;
   */
  city?: string;

  /**
   * @generated from field: optional string professional_background = 6;
   */
  professionalBackground?: string;

  /**
   * @generated from field: repeated string industry_expertise = 7;
   */
  industryExpertise?: string[];

  /**
   * @generated from field: repeated string social_platforms = 8;
   */
  socialPlatforms?: string[];

  /**
   * @generated from field: string network_strength_json = 9;
   */
  networkStrengthJson?: string;

  /**
   * @generated from field: int32 hours_per_week = 10;
   */
  hoursPerWeek?: number;

  /**
   * @generated from field: optional string communication_style = 11;
   */
  communicationStyle?: string;

  /**
   * @generated from field: repeated string community_memberships = 12;
   */
  communityMemberships?: string[];

  /**
   * @generated from field: string status = 13;
   */
  status?: string;

  /**
   * @generated from field: optional string onboarding_completed_at = 14;
   */
  onboardingCompletedAt?: string;

  /**
   * @generated from field: repeated string authorized_product_ids = 15;
   */
  authorizedProductIds?: string[];

  /**
   * @generated from field: int32 daily_llm_quota = 16;
   */
  dailyLlmQuota?: number;

  /**
   * @generated from field: int32 llm_calls_today = 17;
   */
  llmCallsToday?: number;

  /**
   * @generated from field: string llm_quota_reset_at = 18;
   */
  llmQuotaResetAt?: string;

  /**
   * @generated from field: int64 total_earnings_cents = 19;
   */
  totalEarningsCents?: string;

  /**
   * @generated from field: int32 total_closed_deals = 20;
   */
  totalClosedDeals?: number;

  /**
   * @generated from field: optional string invited_by_user_id = 21;
   */
  invitedByUserId?: string;

  /**
   * @generated from field: string created_at = 22;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 23;
   */
  updatedAt?: string;

  /**
   * @generated from field: optional string user_email = 24;
   */
  userEmail?: string;

  /**
   * @generated from field: optional string user_full_name = 25;
   */
  userFullName?: string;
};

/**
 * Describes the message guardianai.v1.referral.SalesAgent.
 * Use `create(SalesAgentSchema)` to create a new message.
 */
export const SalesAgentSchema: GenMessage<SalesAgent, {jsonType: SalesAgentJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 1);

/**
 * @generated from message guardianai.v1.referral.SalesSearchStrategy
 */
export type SalesSearchStrategy = Message<"guardianai.v1.referral.SalesSearchStrategy"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform: string;

  /**
   * @generated from field: string search_queries_json = 5;
   */
  searchQueriesJson: string;

  /**
   * @generated from field: string target_personas_json = 6;
   */
  targetPersonasJson: string;

  /**
   * @generated from field: string generated_at = 7;
   */
  generatedAt: string;

  /**
   * @generated from field: string llm_model = 8;
   */
  llmModel: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;
};

/**
 * @generated from message guardianai.v1.referral.SalesSearchStrategy
 */
export type SalesSearchStrategyJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId?: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform?: string;

  /**
   * @generated from field: string search_queries_json = 5;
   */
  searchQueriesJson?: string;

  /**
   * @generated from field: string target_personas_json = 6;
   */
  targetPersonasJson?: string;

  /**
   * @generated from field: string generated_at = 7;
   */
  generatedAt?: string;

  /**
   * @generated from field: string llm_model = 8;
   */
  llmModel?: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.referral.SalesSearchStrategy.
 * Use `create(SalesSearchStrategySchema)` to create a new message.
 */
export const SalesSearchStrategySchema: GenMessage<SalesSearchStrategy, {jsonType: SalesSearchStrategyJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 2);

/**
 * @generated from message guardianai.v1.referral.SalesLead
 */
export type SalesLead = Message<"guardianai.v1.referral.SalesLead"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string platform = 5;
   */
  platform: string;

  /**
   * @generated from field: optional string profile_link = 6;
   */
  profileLink?: string;

  /**
   * @generated from field: optional string company = 7;
   */
  company?: string;

  /**
   * @generated from field: optional string title_role = 8;
   */
  titleRole?: string;

  /**
   * @generated from field: int32 relevance_score = 9;
   */
  relevanceScore: number;

  /**
   * @generated from field: optional string notes = 10;
   */
  notes?: string;

  /**
   * @generated from field: string status = 11;
   */
  status: string;

  /**
   * @generated from field: string status_updated_at = 12;
   */
  statusUpdatedAt: string;

  /**
   * @generated from field: optional string next_follow_up_at = 13;
   */
  nextFollowUpAt?: string;

  /**
   * @generated from field: optional string last_response_type = 14;
   */
  lastResponseType?: string;

  /**
   * @generated from field: optional string last_response_at = 15;
   */
  lastResponseAt?: string;

  /**
   * @generated from field: optional string strategy_id = 16;
   */
  strategyId?: string;

  /**
   * @generated from field: optional string current_message_node_id = 17;
   */
  currentMessageNodeId?: string;

  /**
   * @generated from field: string created_at = 18;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 19;
   */
  updatedAt: string;

  /**
   * @generated from field: string company_description = 20;
   */
  companyDescription: string;

  /**
   * @generated from field: string current_project = 21;
   */
  currentProject: string;

  /**
   * @generated from field: repeated string additional_product_ids = 22;
   */
  additionalProductIds: string[];
};

/**
 * @generated from message guardianai.v1.referral.SalesLead
 */
export type SalesLeadJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name?: string;

  /**
   * @generated from field: string platform = 5;
   */
  platform?: string;

  /**
   * @generated from field: optional string profile_link = 6;
   */
  profileLink?: string;

  /**
   * @generated from field: optional string company = 7;
   */
  company?: string;

  /**
   * @generated from field: optional string title_role = 8;
   */
  titleRole?: string;

  /**
   * @generated from field: int32 relevance_score = 9;
   */
  relevanceScore?: number;

  /**
   * @generated from field: optional string notes = 10;
   */
  notes?: string;

  /**
   * @generated from field: string status = 11;
   */
  status?: string;

  /**
   * @generated from field: string status_updated_at = 12;
   */
  statusUpdatedAt?: string;

  /**
   * @generated from field: optional string next_follow_up_at = 13;
   */
  nextFollowUpAt?: string;

  /**
   * @generated from field: optional string last_response_type = 14;
   */
  lastResponseType?: string;

  /**
   * @generated from field: optional string last_response_at = 15;
   */
  lastResponseAt?: string;

  /**
   * @generated from field: optional string strategy_id = 16;
   */
  strategyId?: string;

  /**
   * @generated from field: optional string current_message_node_id = 17;
   */
  currentMessageNodeId?: string;

  /**
   * @generated from field: string created_at = 18;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 19;
   */
  updatedAt?: string;

  /**
   * @generated from field: string company_description = 20;
   */
  companyDescription?: string;

  /**
   * @generated from field: string current_project = 21;
   */
  currentProject?: string;

  /**
   * @generated from field: repeated string additional_product_ids = 22;
   */
  additionalProductIds?: string[];
};

/**
 * Describes the message guardianai.v1.referral.SalesLead.
 * Use `create(SalesLeadSchema)` to create a new message.
 */
export const SalesLeadSchema: GenMessage<SalesLead, {jsonType: SalesLeadJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 3);

/**
 * @generated from message guardianai.v1.referral.SalesLeadTableTask
 */
export type SalesLeadTableTask = Message<"guardianai.v1.referral.SalesLeadTableTask"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform: string;

  /**
   * @generated from field: int32 min_leads_required = 5;
   */
  minLeadsRequired: number;

  /**
   * @generated from field: int32 current_lead_count = 6;
   */
  currentLeadCount: number;

  /**
   * @generated from field: bool is_complete = 7;
   */
  isComplete: boolean;

  /**
   * @generated from field: bool submitted_for_strategy = 8;
   */
  submittedForStrategy: boolean;

  /**
   * @generated from field: optional string submitted_at = 9;
   */
  submittedAt?: string;

  /**
   * @generated from field: bool strategy_ready = 10;
   */
  strategyReady: boolean;

  /**
   * @generated from field: optional string strategy_ready_at = 11;
   */
  strategyReadyAt?: string;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt: string;
};

/**
 * @generated from message guardianai.v1.referral.SalesLeadTableTask
 */
export type SalesLeadTableTaskJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId?: string;

  /**
   * @generated from field: string platform = 4;
   */
  platform?: string;

  /**
   * @generated from field: int32 min_leads_required = 5;
   */
  minLeadsRequired?: number;

  /**
   * @generated from field: int32 current_lead_count = 6;
   */
  currentLeadCount?: number;

  /**
   * @generated from field: bool is_complete = 7;
   */
  isComplete?: boolean;

  /**
   * @generated from field: bool submitted_for_strategy = 8;
   */
  submittedForStrategy?: boolean;

  /**
   * @generated from field: optional string submitted_at = 9;
   */
  submittedAt?: string;

  /**
   * @generated from field: bool strategy_ready = 10;
   */
  strategyReady?: boolean;

  /**
   * @generated from field: optional string strategy_ready_at = 11;
   */
  strategyReadyAt?: string;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.referral.SalesLeadTableTask.
 * Use `create(SalesLeadTableTaskSchema)` to create a new message.
 */
export const SalesLeadTableTaskSchema: GenMessage<SalesLeadTableTask, {jsonType: SalesLeadTableTaskJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 4);

/**
 * @generated from message guardianai.v1.referral.SalesMessageStrategy
 */
export type SalesMessageStrategy = Message<"guardianai.v1.referral.SalesMessageStrategy"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string lead_table_task_id = 2;
   */
  leadTableTaskId: string;

  /**
   * @generated from field: string sales_agent_id = 3;
   */
  salesAgentId: string;

  /**
   * @generated from field: string strategy_data_json = 4;
   */
  strategyDataJson: string;

  /**
   * @generated from field: string llm_model = 5;
   */
  llmModel: string;

  /**
   * @generated from field: string generated_at = 6;
   */
  generatedAt: string;

  /**
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * @generated from field: optional string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;
};

/**
 * @generated from message guardianai.v1.referral.SalesMessageStrategy
 */
export type SalesMessageStrategyJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string lead_table_task_id = 2;
   */
  leadTableTaskId?: string;

  /**
   * @generated from field: string sales_agent_id = 3;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string strategy_data_json = 4;
   */
  strategyDataJson?: string;

  /**
   * @generated from field: string llm_model = 5;
   */
  llmModel?: string;

  /**
   * @generated from field: string generated_at = 6;
   */
  generatedAt?: string;

  /**
   * @generated from field: string status = 7;
   */
  status?: string;

  /**
   * @generated from field: optional string error_message = 8;
   */
  errorMessage?: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.referral.SalesMessageStrategy.
 * Use `create(SalesMessageStrategySchema)` to create a new message.
 */
export const SalesMessageStrategySchema: GenMessage<SalesMessageStrategy, {jsonType: SalesMessageStrategyJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 5);

/**
 * @generated from message guardianai.v1.referral.SalesNotification
 */
export type SalesNotification = Message<"guardianai.v1.referral.SalesNotification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId: string;

  /**
   * @generated from field: string notification_type = 3;
   */
  notificationType: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * @generated from field: optional string link = 6;
   */
  link?: string;

  /**
   * @generated from field: optional string lead_id = 7;
   */
  leadId?: string;

  /**
   * @generated from field: bool is_read = 8;
   */
  isRead: boolean;

  /**
   * @generated from field: bool is_emailed = 9;
   */
  isEmailed: boolean;

  /**
   * @generated from field: optional string scheduled_for = 10;
   */
  scheduledFor?: string;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt: string;
};

/**
 * @generated from message guardianai.v1.referral.SalesNotification
 */
export type SalesNotificationJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string notification_type = 3;
   */
  notificationType?: string;

  /**
   * @generated from field: string title = 4;
   */
  title?: string;

  /**
   * @generated from field: string body = 5;
   */
  body?: string;

  /**
   * @generated from field: optional string link = 6;
   */
  link?: string;

  /**
   * @generated from field: optional string lead_id = 7;
   */
  leadId?: string;

  /**
   * @generated from field: bool is_read = 8;
   */
  isRead?: boolean;

  /**
   * @generated from field: bool is_emailed = 9;
   */
  isEmailed?: boolean;

  /**
   * @generated from field: optional string scheduled_for = 10;
   */
  scheduledFor?: string;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.referral.SalesNotification.
 * Use `create(SalesNotificationSchema)` to create a new message.
 */
export const SalesNotificationSchema: GenMessage<SalesNotification, {jsonType: SalesNotificationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 6);

/**
 * @generated from message guardianai.v1.referral.ReferralAttribution
 */
export type ReferralAttribution = Message<"guardianai.v1.referral.ReferralAttribution"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId: string;

  /**
   * @generated from field: optional string sales_lead_id = 3;
   */
  salesLeadId?: string;

  /**
   * @generated from field: string product_id = 4;
   */
  productId: string;

  /**
   * @generated from field: string customer_name = 5;
   */
  customerName: string;

  /**
   * @generated from field: optional string customer_email = 6;
   */
  customerEmail?: string;

  /**
   * @generated from field: optional string customer_company = 7;
   */
  customerCompany?: string;

  /**
   * @generated from field: optional int64 attributed_revenue_cents = 8;
   */
  attributedRevenueCents?: bigint;

  /**
   * @generated from field: optional int64 commission_cents = 9;
   */
  commissionCents?: bigint;

  /**
   * @generated from field: double commission_rate_snapshot = 10;
   */
  commissionRateSnapshot: number;

  /**
   * @generated from field: string status = 11;
   */
  status: string;

  /**
   * @generated from field: optional string verified_by_user_id = 12;
   */
  verifiedByUserId?: string;

  /**
   * @generated from field: optional string verified_at = 13;
   */
  verifiedAt?: string;

  /**
   * @generated from field: optional string paid_at = 14;
   */
  paidAt?: string;

  /**
   * @generated from field: optional string admin_notes = 15;
   */
  adminNotes?: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;

  /**
   * Link-based vs manual attribution
   *
   * @generated from field: optional string referral_code = 18;
   */
  referralCode?: string;

  /**
   * Explicit agent ID for link sales
   *
   * @generated from field: optional string referral_agent_id = 19;
   */
  referralAgentId?: string;

  /**
   * "manual_crm" | "referral_link" | "webhook"
   *
   * @generated from field: string source = 20;
   */
  source: string;
};

/**
 * @generated from message guardianai.v1.referral.ReferralAttribution
 */
export type ReferralAttributionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId?: string;

  /**
   * @generated from field: optional string sales_lead_id = 3;
   */
  salesLeadId?: string;

  /**
   * @generated from field: string product_id = 4;
   */
  productId?: string;

  /**
   * @generated from field: string customer_name = 5;
   */
  customerName?: string;

  /**
   * @generated from field: optional string customer_email = 6;
   */
  customerEmail?: string;

  /**
   * @generated from field: optional string customer_company = 7;
   */
  customerCompany?: string;

  /**
   * @generated from field: optional int64 attributed_revenue_cents = 8;
   */
  attributedRevenueCents?: string;

  /**
   * @generated from field: optional int64 commission_cents = 9;
   */
  commissionCents?: string;

  /**
   * @generated from field: double commission_rate_snapshot = 10;
   */
  commissionRateSnapshot?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string status = 11;
   */
  status?: string;

  /**
   * @generated from field: optional string verified_by_user_id = 12;
   */
  verifiedByUserId?: string;

  /**
   * @generated from field: optional string verified_at = 13;
   */
  verifiedAt?: string;

  /**
   * @generated from field: optional string paid_at = 14;
   */
  paidAt?: string;

  /**
   * @generated from field: optional string admin_notes = 15;
   */
  adminNotes?: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt?: string;

  /**
   * Link-based vs manual attribution
   *
   * @generated from field: optional string referral_code = 18;
   */
  referralCode?: string;

  /**
   * Explicit agent ID for link sales
   *
   * @generated from field: optional string referral_agent_id = 19;
   */
  referralAgentId?: string;

  /**
   * "manual_crm" | "referral_link" | "webhook"
   *
   * @generated from field: string source = 20;
   */
  source?: string;
};

/**
 * Describes the message guardianai.v1.referral.ReferralAttribution.
 * Use `create(ReferralAttributionSchema)` to create a new message.
 */
export const ReferralAttributionSchema: GenMessage<ReferralAttribution, {jsonType: ReferralAttributionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 7);

/**
 * @generated from message guardianai.v1.referral.ReferralLink
 */
export type ReferralLink = Message<"guardianai.v1.referral.ReferralLink"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId: string;

  /**
   * @generated from field: string product_name = 4;
   */
  productName: string;

  /**
   * 8-char alphanumeric
   *
   * @generated from field: string referral_code = 5;
   */
  referralCode: string;

  /**
   * Full URL with ?ref= param
   *
   * @generated from field: string checkout_url = 6;
   */
  checkoutUrl: string;

  /**
   * Determines URL format
   *
   * @generated from field: bool is_external_product = 7;
   */
  isExternalProduct: boolean;

  /**
   * @generated from field: int32 total_clicks = 8;
   */
  totalClicks: number;

  /**
   * @generated from field: int32 total_conversions = 9;
   */
  totalConversions: number;

  /**
   * @generated from field: int64 total_revenue_cents = 10;
   */
  totalRevenueCents: bigint;

  /**
   * @generated from field: int64 total_commission_cents = 11;
   */
  totalCommissionCents: bigint;

  /**
   * @generated from field: double commission_rate = 12;
   */
  commissionRate: number;

  /**
   * @generated from field: int32 commission_duration_days = 13;
   */
  commissionDurationDays: number;

  /**
   * @generated from field: bool commission_on_renewals = 14;
   */
  commissionOnRenewals: boolean;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt: string;
};

/**
 * @generated from message guardianai.v1.referral.ReferralLink
 */
export type ReferralLinkJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string sales_agent_id = 2;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string product_id = 3;
   */
  productId?: string;

  /**
   * @generated from field: string product_name = 4;
   */
  productName?: string;

  /**
   * 8-char alphanumeric
   *
   * @generated from field: string referral_code = 5;
   */
  referralCode?: string;

  /**
   * Full URL with ?ref= param
   *
   * @generated from field: string checkout_url = 6;
   */
  checkoutUrl?: string;

  /**
   * Determines URL format
   *
   * @generated from field: bool is_external_product = 7;
   */
  isExternalProduct?: boolean;

  /**
   * @generated from field: int32 total_clicks = 8;
   */
  totalClicks?: number;

  /**
   * @generated from field: int32 total_conversions = 9;
   */
  totalConversions?: number;

  /**
   * @generated from field: int64 total_revenue_cents = 10;
   */
  totalRevenueCents?: string;

  /**
   * @generated from field: int64 total_commission_cents = 11;
   */
  totalCommissionCents?: string;

  /**
   * @generated from field: double commission_rate = 12;
   */
  commissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int32 commission_duration_days = 13;
   */
  commissionDurationDays?: number;

  /**
   * @generated from field: bool commission_on_renewals = 14;
   */
  commissionOnRenewals?: boolean;

  /**
   * @generated from field: string created_at = 15;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.referral.ReferralLink.
 * Use `create(ReferralLinkSchema)` to create a new message.
 */
export const ReferralLinkSchema: GenMessage<ReferralLink, {jsonType: ReferralLinkJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 8);

/**
 * @generated from message guardianai.v1.referral.SalesOnboardingConfig
 */
export type SalesOnboardingConfig = Message<"guardianai.v1.referral.SalesOnboardingConfig"> & {
  /**
   * @generated from field: string youtube_video_url = 1;
   */
  youtubeVideoUrl: string;

  /**
   * @generated from field: string updated_at = 2;
   */
  updatedAt: string;
};

/**
 * @generated from message guardianai.v1.referral.SalesOnboardingConfig
 */
export type SalesOnboardingConfigJson = {
  /**
   * @generated from field: string youtube_video_url = 1;
   */
  youtubeVideoUrl?: string;

  /**
   * @generated from field: string updated_at = 2;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.referral.SalesOnboardingConfig.
 * Use `create(SalesOnboardingConfigSchema)` to create a new message.
 */
export const SalesOnboardingConfigSchema: GenMessage<SalesOnboardingConfig, {jsonType: SalesOnboardingConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 9);

/**
 * @generated from message guardianai.v1.referral.ProductCatalogEntry
 */
export type ProductCatalogEntry = Message<"guardianai.v1.referral.ProductCatalogEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string frontend_slug = 2;
   */
  frontendSlug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: double base_commission_rate = 6;
   */
  baseCommissionRate: number;

  /**
   * @generated from field: bool is_available_for_sales = 7;
   */
  isAvailableForSales: boolean;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * New CMS Fields
   *
   * @generated from field: optional string image_url = 9;
   */
  imageUrl?: string;

  /**
   * Serialized JSONB
   *
   * @generated from field: string metadata_json = 10;
   */
  metadataJson: string;

  /**
   * Serialized JSONB
   *
   * @generated from field: string structured_data_json = 11;
   */
  structuredDataJson: string;

  /**
   * @generated from field: repeated string tags = 12;
   */
  tags: string[];

  /**
   * @generated from field: repeated string features = 13;
   */
  features: string[];

  /**
   * @generated from field: optional string price_display = 14;
   */
  priceDisplay?: string;

  /**
   * @generated from field: optional string period_display = 15;
   */
  periodDisplay?: string;

  /**
   * @generated from field: optional string stripe_url = 16;
   */
  stripeUrl?: string;

  /**
   * @generated from field: optional string contact_category = 17;
   */
  contactCategory?: string;

  /**
   * @generated from field: optional string stripe_price_id = 18;
   */
  stripePriceId?: string;
};

/**
 * @generated from message guardianai.v1.referral.ProductCatalogEntry
 */
export type ProductCatalogEntryJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string frontend_slug = 2;
   */
  frontendSlug?: string;

  /**
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: string category = 5;
   */
  category?: string;

  /**
   * @generated from field: double base_commission_rate = 6;
   */
  baseCommissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: bool is_available_for_sales = 7;
   */
  isAvailableForSales?: boolean;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt?: string;

  /**
   * New CMS Fields
   *
   * @generated from field: optional string image_url = 9;
   */
  imageUrl?: string;

  /**
   * Serialized JSONB
   *
   * @generated from field: string metadata_json = 10;
   */
  metadataJson?: string;

  /**
   * Serialized JSONB
   *
   * @generated from field: string structured_data_json = 11;
   */
  structuredDataJson?: string;

  /**
   * @generated from field: repeated string tags = 12;
   */
  tags?: string[];

  /**
   * @generated from field: repeated string features = 13;
   */
  features?: string[];

  /**
   * @generated from field: optional string price_display = 14;
   */
  priceDisplay?: string;

  /**
   * @generated from field: optional string period_display = 15;
   */
  periodDisplay?: string;

  /**
   * @generated from field: optional string stripe_url = 16;
   */
  stripeUrl?: string;

  /**
   * @generated from field: optional string contact_category = 17;
   */
  contactCategory?: string;

  /**
   * @generated from field: optional string stripe_price_id = 18;
   */
  stripePriceId?: string;
};

/**
 * Describes the message guardianai.v1.referral.ProductCatalogEntry.
 * Use `create(ProductCatalogEntrySchema)` to create a new message.
 */
export const ProductCatalogEntrySchema: GenMessage<ProductCatalogEntry, {jsonType: ProductCatalogEntryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 10);

/**
 * @generated from message guardianai.v1.referral.ListProductCatalogRequest
 */
export type ListProductCatalogRequest = Message<"guardianai.v1.referral.ListProductCatalogRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.referral.ListProductCatalogRequest
 */
export type ListProductCatalogRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListProductCatalogRequest.
 * Use `create(ListProductCatalogRequestSchema)` to create a new message.
 */
export const ListProductCatalogRequestSchema: GenMessage<ListProductCatalogRequest, {jsonType: ListProductCatalogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 11);

/**
 * @generated from message guardianai.v1.referral.ListProductCatalogResponse
 */
export type ListProductCatalogResponse = Message<"guardianai.v1.referral.ListProductCatalogResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.ProductCatalogEntry products = 1;
   */
  products: ProductCatalogEntry[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.referral.ListProductCatalogResponse
 */
export type ListProductCatalogResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.ProductCatalogEntry products = 1;
   */
  products?: ProductCatalogEntryJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListProductCatalogResponse.
 * Use `create(ListProductCatalogResponseSchema)` to create a new message.
 */
export const ListProductCatalogResponseSchema: GenMessage<ListProductCatalogResponse, {jsonType: ListProductCatalogResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 12);

/**
 * @generated from message guardianai.v1.referral.CreateProductCatalogRequest
 */
export type CreateProductCatalogRequest = Message<"guardianai.v1.referral.CreateProductCatalogRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.ProductCatalogEntry product = 1;
   */
  product?: ProductCatalogEntry;
};

/**
 * @generated from message guardianai.v1.referral.CreateProductCatalogRequest
 */
export type CreateProductCatalogRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.ProductCatalogEntry product = 1;
   */
  product?: ProductCatalogEntryJson;
};

/**
 * Describes the message guardianai.v1.referral.CreateProductCatalogRequest.
 * Use `create(CreateProductCatalogRequestSchema)` to create a new message.
 */
export const CreateProductCatalogRequestSchema: GenMessage<CreateProductCatalogRequest, {jsonType: CreateProductCatalogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 13);

/**
 * @generated from message guardianai.v1.referral.UpdateProductCatalogRequest
 */
export type UpdateProductCatalogRequest = Message<"guardianai.v1.referral.UpdateProductCatalogRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.ProductCatalogEntry product = 1;
   */
  product?: ProductCatalogEntry;
};

/**
 * @generated from message guardianai.v1.referral.UpdateProductCatalogRequest
 */
export type UpdateProductCatalogRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.ProductCatalogEntry product = 1;
   */
  product?: ProductCatalogEntryJson;
};

/**
 * Describes the message guardianai.v1.referral.UpdateProductCatalogRequest.
 * Use `create(UpdateProductCatalogRequestSchema)` to create a new message.
 */
export const UpdateProductCatalogRequestSchema: GenMessage<UpdateProductCatalogRequest, {jsonType: UpdateProductCatalogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 14);

/**
 * @generated from message guardianai.v1.referral.DeleteProductCatalogRequest
 */
export type DeleteProductCatalogRequest = Message<"guardianai.v1.referral.DeleteProductCatalogRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.DeleteProductCatalogRequest
 */
export type DeleteProductCatalogRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.DeleteProductCatalogRequest.
 * Use `create(DeleteProductCatalogRequestSchema)` to create a new message.
 */
export const DeleteProductCatalogRequestSchema: GenMessage<DeleteProductCatalogRequest, {jsonType: DeleteProductCatalogRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 15);

/**
 * @generated from message guardianai.v1.referral.DeleteProductCatalogResponse
 */
export type DeleteProductCatalogResponse = Message<"guardianai.v1.referral.DeleteProductCatalogResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.DeleteProductCatalogResponse
 */
export type DeleteProductCatalogResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.DeleteProductCatalogResponse.
 * Use `create(DeleteProductCatalogResponseSchema)` to create a new message.
 */
export const DeleteProductCatalogResponseSchema: GenMessage<DeleteProductCatalogResponse, {jsonType: DeleteProductCatalogResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 16);

/**
 * --- Products ---
 *
 * @generated from message guardianai.v1.referral.CreateProductRequest
 */
export type CreateProductRequest = Message<"guardianai.v1.referral.CreateProductRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesPoolProduct product = 1;
   */
  product?: SalesPoolProduct;
};

/**
 * --- Products ---
 *
 * @generated from message guardianai.v1.referral.CreateProductRequest
 */
export type CreateProductRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesPoolProduct product = 1;
   */
  product?: SalesPoolProductJson;
};

/**
 * Describes the message guardianai.v1.referral.CreateProductRequest.
 * Use `create(CreateProductRequestSchema)` to create a new message.
 */
export const CreateProductRequestSchema: GenMessage<CreateProductRequest, {jsonType: CreateProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 17);

/**
 * @generated from message guardianai.v1.referral.UpdateProductRequest
 */
export type UpdateProductRequest = Message<"guardianai.v1.referral.UpdateProductRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesPoolProduct product = 1;
   */
  product?: SalesPoolProduct;
};

/**
 * @generated from message guardianai.v1.referral.UpdateProductRequest
 */
export type UpdateProductRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesPoolProduct product = 1;
   */
  product?: SalesPoolProductJson;
};

/**
 * Describes the message guardianai.v1.referral.UpdateProductRequest.
 * Use `create(UpdateProductRequestSchema)` to create a new message.
 */
export const UpdateProductRequestSchema: GenMessage<UpdateProductRequest, {jsonType: UpdateProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 18);

/**
 * @generated from message guardianai.v1.referral.DeleteProductRequest
 */
export type DeleteProductRequest = Message<"guardianai.v1.referral.DeleteProductRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.DeleteProductRequest
 */
export type DeleteProductRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.DeleteProductRequest.
 * Use `create(DeleteProductRequestSchema)` to create a new message.
 */
export const DeleteProductRequestSchema: GenMessage<DeleteProductRequest, {jsonType: DeleteProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 19);

/**
 * @generated from message guardianai.v1.referral.DeleteProductResponse
 */
export type DeleteProductResponse = Message<"guardianai.v1.referral.DeleteProductResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.DeleteProductResponse
 */
export type DeleteProductResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.DeleteProductResponse.
 * Use `create(DeleteProductResponseSchema)` to create a new message.
 */
export const DeleteProductResponseSchema: GenMessage<DeleteProductResponse, {jsonType: DeleteProductResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 20);

/**
 * @generated from message guardianai.v1.referral.ListProductsRequest
 */
export type ListProductsRequest = Message<"guardianai.v1.referral.ListProductsRequest"> & {
  /**
   * @generated from field: optional bool is_active = 1;
   */
  isActive?: boolean;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.referral.ListProductsRequest
 */
export type ListProductsRequestJson = {
  /**
   * @generated from field: optional bool is_active = 1;
   */
  isActive?: boolean;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema: GenMessage<ListProductsRequest, {jsonType: ListProductsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 21);

/**
 * @generated from message guardianai.v1.referral.ListProductsResponse
 */
export type ListProductsResponse = Message<"guardianai.v1.referral.ListProductsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesPoolProduct products = 1;
   */
  products: SalesPoolProduct[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.referral.ListProductsResponse
 */
export type ListProductsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesPoolProduct products = 1;
   */
  products?: SalesPoolProductJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema: GenMessage<ListProductsResponse, {jsonType: ListProductsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 22);

/**
 * @generated from message guardianai.v1.referral.GetProductRequest
 */
export type GetProductRequest = Message<"guardianai.v1.referral.GetProductRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.GetProductRequest
 */
export type GetProductRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.GetProductRequest.
 * Use `create(GetProductRequestSchema)` to create a new message.
 */
export const GetProductRequestSchema: GenMessage<GetProductRequest, {jsonType: GetProductRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 23);

/**
 * @generated from message guardianai.v1.referral.ProductResponse
 */
export type ProductResponse = Message<"guardianai.v1.referral.ProductResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesPoolProduct product = 1;
   */
  product?: SalesPoolProduct;
};

/**
 * @generated from message guardianai.v1.referral.ProductResponse
 */
export type ProductResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesPoolProduct product = 1;
   */
  product?: SalesPoolProductJson;
};

/**
 * Describes the message guardianai.v1.referral.ProductResponse.
 * Use `create(ProductResponseSchema)` to create a new message.
 */
export const ProductResponseSchema: GenMessage<ProductResponse, {jsonType: ProductResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 24);

/**
 * --- Agents ---
 *
 * @generated from message guardianai.v1.referral.InviteSalesAgentRequest
 */
export type InviteSalesAgentRequest = Message<"guardianai.v1.referral.InviteSalesAgentRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: repeated string authorized_product_ids = 2;
   */
  authorizedProductIds: string[];
};

/**
 * --- Agents ---
 *
 * @generated from message guardianai.v1.referral.InviteSalesAgentRequest
 */
export type InviteSalesAgentRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: repeated string authorized_product_ids = 2;
   */
  authorizedProductIds?: string[];
};

/**
 * Describes the message guardianai.v1.referral.InviteSalesAgentRequest.
 * Use `create(InviteSalesAgentRequestSchema)` to create a new message.
 */
export const InviteSalesAgentRequestSchema: GenMessage<InviteSalesAgentRequest, {jsonType: InviteSalesAgentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 25);

/**
 * @generated from message guardianai.v1.referral.InviteSalesAgentResponse
 */
export type InviteSalesAgentResponse = Message<"guardianai.v1.referral.InviteSalesAgentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string magic_link_id = 2;
   */
  magicLinkId: string;
};

/**
 * @generated from message guardianai.v1.referral.InviteSalesAgentResponse
 */
export type InviteSalesAgentResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string magic_link_id = 2;
   */
  magicLinkId?: string;
};

/**
 * Describes the message guardianai.v1.referral.InviteSalesAgentResponse.
 * Use `create(InviteSalesAgentResponseSchema)` to create a new message.
 */
export const InviteSalesAgentResponseSchema: GenMessage<InviteSalesAgentResponse, {jsonType: InviteSalesAgentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 26);

/**
 * @generated from message guardianai.v1.referral.ListSalesAgentsRequest
 */
export type ListSalesAgentsRequest = Message<"guardianai.v1.referral.ListSalesAgentsRequest"> & {
  /**
   * @generated from field: optional string status = 1;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.referral.ListSalesAgentsRequest
 */
export type ListSalesAgentsRequestJson = {
  /**
   * @generated from field: optional string status = 1;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListSalesAgentsRequest.
 * Use `create(ListSalesAgentsRequestSchema)` to create a new message.
 */
export const ListSalesAgentsRequestSchema: GenMessage<ListSalesAgentsRequest, {jsonType: ListSalesAgentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 27);

/**
 * @generated from message guardianai.v1.referral.ListSalesAgentsResponse
 */
export type ListSalesAgentsResponse = Message<"guardianai.v1.referral.ListSalesAgentsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesAgent agents = 1;
   */
  agents: SalesAgent[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.referral.ListSalesAgentsResponse
 */
export type ListSalesAgentsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesAgent agents = 1;
   */
  agents?: SalesAgentJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListSalesAgentsResponse.
 * Use `create(ListSalesAgentsResponseSchema)` to create a new message.
 */
export const ListSalesAgentsResponseSchema: GenMessage<ListSalesAgentsResponse, {jsonType: ListSalesAgentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 28);

/**
 * @generated from message guardianai.v1.referral.GetSalesAgentRequest
 */
export type GetSalesAgentRequest = Message<"guardianai.v1.referral.GetSalesAgentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.GetSalesAgentRequest
 */
export type GetSalesAgentRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.GetSalesAgentRequest.
 * Use `create(GetSalesAgentRequestSchema)` to create a new message.
 */
export const GetSalesAgentRequestSchema: GenMessage<GetSalesAgentRequest, {jsonType: GetSalesAgentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 29);

/**
 * @generated from message guardianai.v1.referral.SuspendSalesAgentRequest
 */
export type SuspendSalesAgentRequest = Message<"guardianai.v1.referral.SuspendSalesAgentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.SuspendSalesAgentRequest
 */
export type SuspendSalesAgentRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.SuspendSalesAgentRequest.
 * Use `create(SuspendSalesAgentRequestSchema)` to create a new message.
 */
export const SuspendSalesAgentRequestSchema: GenMessage<SuspendSalesAgentRequest, {jsonType: SuspendSalesAgentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 30);

/**
 * @generated from message guardianai.v1.referral.UpdateAgentProductAuthRequest
 */
export type UpdateAgentProductAuthRequest = Message<"guardianai.v1.referral.UpdateAgentProductAuthRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated string authorized_product_ids = 2;
   */
  authorizedProductIds: string[];
};

/**
 * @generated from message guardianai.v1.referral.UpdateAgentProductAuthRequest
 */
export type UpdateAgentProductAuthRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: repeated string authorized_product_ids = 2;
   */
  authorizedProductIds?: string[];
};

/**
 * Describes the message guardianai.v1.referral.UpdateAgentProductAuthRequest.
 * Use `create(UpdateAgentProductAuthRequestSchema)` to create a new message.
 */
export const UpdateAgentProductAuthRequestSchema: GenMessage<UpdateAgentProductAuthRequest, {jsonType: UpdateAgentProductAuthRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 31);

/**
 * @generated from message guardianai.v1.referral.SalesAgentResponse
 */
export type SalesAgentResponse = Message<"guardianai.v1.referral.SalesAgentResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent = 1;
   */
  agent?: SalesAgent;
};

/**
 * @generated from message guardianai.v1.referral.SalesAgentResponse
 */
export type SalesAgentResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent = 1;
   */
  agent?: SalesAgentJson;
};

/**
 * Describes the message guardianai.v1.referral.SalesAgentResponse.
 * Use `create(SalesAgentResponseSchema)` to create a new message.
 */
export const SalesAgentResponseSchema: GenMessage<SalesAgentResponse, {jsonType: SalesAgentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 32);

/**
 * --- Attributions ---
 *
 * @generated from message guardianai.v1.referral.ListAttributionsRequest
 */
export type ListAttributionsRequest = Message<"guardianai.v1.referral.ListAttributionsRequest"> & {
  /**
   * @generated from field: optional string sales_agent_id = 1;
   */
  salesAgentId?: string;

  /**
   * @generated from field: optional string status = 2;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * --- Attributions ---
 *
 * @generated from message guardianai.v1.referral.ListAttributionsRequest
 */
export type ListAttributionsRequestJson = {
  /**
   * @generated from field: optional string sales_agent_id = 1;
   */
  salesAgentId?: string;

  /**
   * @generated from field: optional string status = 2;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListAttributionsRequest.
 * Use `create(ListAttributionsRequestSchema)` to create a new message.
 */
export const ListAttributionsRequestSchema: GenMessage<ListAttributionsRequest, {jsonType: ListAttributionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 33);

/**
 * @generated from message guardianai.v1.referral.ListAttributionsResponse
 */
export type ListAttributionsResponse = Message<"guardianai.v1.referral.ListAttributionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralAttribution attributions = 1;
   */
  attributions: ReferralAttribution[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.referral.ListAttributionsResponse
 */
export type ListAttributionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralAttribution attributions = 1;
   */
  attributions?: ReferralAttributionJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListAttributionsResponse.
 * Use `create(ListAttributionsResponseSchema)` to create a new message.
 */
export const ListAttributionsResponseSchema: GenMessage<ListAttributionsResponse, {jsonType: ListAttributionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 34);

/**
 * @generated from message guardianai.v1.referral.VerifyAttributionRequest
 */
export type VerifyAttributionRequest = Message<"guardianai.v1.referral.VerifyAttributionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 revenue_cents = 2;
   */
  revenueCents: bigint;
};

/**
 * @generated from message guardianai.v1.referral.VerifyAttributionRequest
 */
export type VerifyAttributionRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: int64 revenue_cents = 2;
   */
  revenueCents?: string;
};

/**
 * Describes the message guardianai.v1.referral.VerifyAttributionRequest.
 * Use `create(VerifyAttributionRequestSchema)` to create a new message.
 */
export const VerifyAttributionRequestSchema: GenMessage<VerifyAttributionRequest, {jsonType: VerifyAttributionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 35);

/**
 * @generated from message guardianai.v1.referral.RejectAttributionRequest
 */
export type RejectAttributionRequest = Message<"guardianai.v1.referral.RejectAttributionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string notes = 2;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.referral.RejectAttributionRequest
 */
export type RejectAttributionRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string notes = 2;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.referral.RejectAttributionRequest.
 * Use `create(RejectAttributionRequestSchema)` to create a new message.
 */
export const RejectAttributionRequestSchema: GenMessage<RejectAttributionRequest, {jsonType: RejectAttributionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 36);

/**
 * @generated from message guardianai.v1.referral.MarkAttributionPaidRequest
 */
export type MarkAttributionPaidRequest = Message<"guardianai.v1.referral.MarkAttributionPaidRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.MarkAttributionPaidRequest
 */
export type MarkAttributionPaidRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.MarkAttributionPaidRequest.
 * Use `create(MarkAttributionPaidRequestSchema)` to create a new message.
 */
export const MarkAttributionPaidRequestSchema: GenMessage<MarkAttributionPaidRequest, {jsonType: MarkAttributionPaidRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 37);

/**
 * @generated from message guardianai.v1.referral.AttributionResponse
 */
export type AttributionResponse = Message<"guardianai.v1.referral.AttributionResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.ReferralAttribution attribution = 1;
   */
  attribution?: ReferralAttribution;
};

/**
 * @generated from message guardianai.v1.referral.AttributionResponse
 */
export type AttributionResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.ReferralAttribution attribution = 1;
   */
  attribution?: ReferralAttributionJson;
};

/**
 * Describes the message guardianai.v1.referral.AttributionResponse.
 * Use `create(AttributionResponseSchema)` to create a new message.
 */
export const AttributionResponseSchema: GenMessage<AttributionResponse, {jsonType: AttributionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 38);

/**
 * --- Dashboard ---
 *
 * @generated from message guardianai.v1.referral.GetReferralDashboardStatsRequest
 */
export type GetReferralDashboardStatsRequest = Message<"guardianai.v1.referral.GetReferralDashboardStatsRequest"> & {
};

/**
 * --- Dashboard ---
 *
 * @generated from message guardianai.v1.referral.GetReferralDashboardStatsRequest
 */
export type GetReferralDashboardStatsRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.GetReferralDashboardStatsRequest.
 * Use `create(GetReferralDashboardStatsRequestSchema)` to create a new message.
 */
export const GetReferralDashboardStatsRequestSchema: GenMessage<GetReferralDashboardStatsRequest, {jsonType: GetReferralDashboardStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 39);

/**
 * @generated from message guardianai.v1.referral.ReferralDashboardStatsResponse
 */
export type ReferralDashboardStatsResponse = Message<"guardianai.v1.referral.ReferralDashboardStatsResponse"> & {
  /**
   * @generated from field: int32 total_agents = 1;
   */
  totalAgents: number;

  /**
   * @generated from field: int32 active_agents = 2;
   */
  activeAgents: number;

  /**
   * @generated from field: int32 total_leads = 3;
   */
  totalLeads: number;

  /**
   * @generated from field: int32 closed_deals = 4;
   */
  closedDeals: number;

  /**
   * @generated from field: int64 total_commission_paid_cents = 5;
   */
  totalCommissionPaidCents: bigint;

  /**
   * @generated from field: int64 total_commission_pending_cents = 6;
   */
  totalCommissionPendingCents: bigint;
};

/**
 * @generated from message guardianai.v1.referral.ReferralDashboardStatsResponse
 */
export type ReferralDashboardStatsResponseJson = {
  /**
   * @generated from field: int32 total_agents = 1;
   */
  totalAgents?: number;

  /**
   * @generated from field: int32 active_agents = 2;
   */
  activeAgents?: number;

  /**
   * @generated from field: int32 total_leads = 3;
   */
  totalLeads?: number;

  /**
   * @generated from field: int32 closed_deals = 4;
   */
  closedDeals?: number;

  /**
   * @generated from field: int64 total_commission_paid_cents = 5;
   */
  totalCommissionPaidCents?: string;

  /**
   * @generated from field: int64 total_commission_pending_cents = 6;
   */
  totalCommissionPendingCents?: string;
};

/**
 * Describes the message guardianai.v1.referral.ReferralDashboardStatsResponse.
 * Use `create(ReferralDashboardStatsResponseSchema)` to create a new message.
 */
export const ReferralDashboardStatsResponseSchema: GenMessage<ReferralDashboardStatsResponse, {jsonType: ReferralDashboardStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 40);

/**
 * @generated from message guardianai.v1.referral.GetSalesOnboardingConfigRequest
 */
export type GetSalesOnboardingConfigRequest = Message<"guardianai.v1.referral.GetSalesOnboardingConfigRequest"> & {
};

/**
 * @generated from message guardianai.v1.referral.GetSalesOnboardingConfigRequest
 */
export type GetSalesOnboardingConfigRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.GetSalesOnboardingConfigRequest.
 * Use `create(GetSalesOnboardingConfigRequestSchema)` to create a new message.
 */
export const GetSalesOnboardingConfigRequestSchema: GenMessage<GetSalesOnboardingConfigRequest, {jsonType: GetSalesOnboardingConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 41);

/**
 * @generated from message guardianai.v1.referral.UpdateSalesOnboardingConfigRequest
 */
export type UpdateSalesOnboardingConfigRequest = Message<"guardianai.v1.referral.UpdateSalesOnboardingConfigRequest"> & {
  /**
   * @generated from field: string youtube_video_url = 1;
   */
  youtubeVideoUrl: string;
};

/**
 * @generated from message guardianai.v1.referral.UpdateSalesOnboardingConfigRequest
 */
export type UpdateSalesOnboardingConfigRequestJson = {
  /**
   * @generated from field: string youtube_video_url = 1;
   */
  youtubeVideoUrl?: string;
};

/**
 * Describes the message guardianai.v1.referral.UpdateSalesOnboardingConfigRequest.
 * Use `create(UpdateSalesOnboardingConfigRequestSchema)` to create a new message.
 */
export const UpdateSalesOnboardingConfigRequestSchema: GenMessage<UpdateSalesOnboardingConfigRequest, {jsonType: UpdateSalesOnboardingConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 42);

/**
 * @generated from message guardianai.v1.referral.SalesOnboardingConfigResponse
 */
export type SalesOnboardingConfigResponse = Message<"guardianai.v1.referral.SalesOnboardingConfigResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesOnboardingConfig config = 1;
   */
  config?: SalesOnboardingConfig;
};

/**
 * @generated from message guardianai.v1.referral.SalesOnboardingConfigResponse
 */
export type SalesOnboardingConfigResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesOnboardingConfig config = 1;
   */
  config?: SalesOnboardingConfigJson;
};

/**
 * Describes the message guardianai.v1.referral.SalesOnboardingConfigResponse.
 * Use `create(SalesOnboardingConfigResponseSchema)` to create a new message.
 */
export const SalesOnboardingConfigResponseSchema: GenMessage<SalesOnboardingConfigResponse, {jsonType: SalesOnboardingConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 43);

/**
 * @generated from message guardianai.v1.referral.ApproveSalesAgentRequest
 */
export type ApproveSalesAgentRequest = Message<"guardianai.v1.referral.ApproveSalesAgentRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.ApproveSalesAgentRequest
 */
export type ApproveSalesAgentRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.ApproveSalesAgentRequest.
 * Use `create(ApproveSalesAgentRequestSchema)` to create a new message.
 */
export const ApproveSalesAgentRequestSchema: GenMessage<ApproveSalesAgentRequest, {jsonType: ApproveSalesAgentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 44);

/**
 * --- Onboarding ---
 *
 * @generated from message guardianai.v1.referral.GetOnboardingProfileRequest
 */
export type GetOnboardingProfileRequest = Message<"guardianai.v1.referral.GetOnboardingProfileRequest"> & {
};

/**
 * --- Onboarding ---
 *
 * @generated from message guardianai.v1.referral.GetOnboardingProfileRequest
 */
export type GetOnboardingProfileRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.GetOnboardingProfileRequest.
 * Use `create(GetOnboardingProfileRequestSchema)` to create a new message.
 */
export const GetOnboardingProfileRequestSchema: GenMessage<GetOnboardingProfileRequest, {jsonType: GetOnboardingProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 45);

/**
 * @generated from message guardianai.v1.referral.OnboardingProfileResponse
 */
export type OnboardingProfileResponse = Message<"guardianai.v1.referral.OnboardingProfileResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent = 1;
   */
  agent?: SalesAgent;

  /**
   * @generated from field: repeated guardianai.v1.referral.SalesPoolProduct authorized_products = 2;
   */
  authorizedProducts: SalesPoolProduct[];
};

/**
 * @generated from message guardianai.v1.referral.OnboardingProfileResponse
 */
export type OnboardingProfileResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent = 1;
   */
  agent?: SalesAgentJson;

  /**
   * @generated from field: repeated guardianai.v1.referral.SalesPoolProduct authorized_products = 2;
   */
  authorizedProducts?: SalesPoolProductJson[];
};

/**
 * Describes the message guardianai.v1.referral.OnboardingProfileResponse.
 * Use `create(OnboardingProfileResponseSchema)` to create a new message.
 */
export const OnboardingProfileResponseSchema: GenMessage<OnboardingProfileResponse, {jsonType: OnboardingProfileResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 46);

/**
 * @generated from message guardianai.v1.referral.SubmitOnboardingProfileRequest
 */
export type SubmitOnboardingProfileRequest = Message<"guardianai.v1.referral.SubmitOnboardingProfileRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent_profile = 1;
   */
  agentProfile?: SalesAgent;
};

/**
 * @generated from message guardianai.v1.referral.SubmitOnboardingProfileRequest
 */
export type SubmitOnboardingProfileRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent_profile = 1;
   */
  agentProfile?: SalesAgentJson;
};

/**
 * Describes the message guardianai.v1.referral.SubmitOnboardingProfileRequest.
 * Use `create(SubmitOnboardingProfileRequestSchema)` to create a new message.
 */
export const SubmitOnboardingProfileRequestSchema: GenMessage<SubmitOnboardingProfileRequest, {jsonType: SubmitOnboardingProfileRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 47);

/**
 * @generated from message guardianai.v1.referral.SubmitOnboardingProfileResponse
 */
export type SubmitOnboardingProfileResponse = Message<"guardianai.v1.referral.SubmitOnboardingProfileResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.SubmitOnboardingProfileResponse
 */
export type SubmitOnboardingProfileResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.SubmitOnboardingProfileResponse.
 * Use `create(SubmitOnboardingProfileResponseSchema)` to create a new message.
 */
export const SubmitOnboardingProfileResponseSchema: GenMessage<SubmitOnboardingProfileResponse, {jsonType: SubmitOnboardingProfileResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 48);

/**
 * --- Strategies ---
 *
 * @generated from message guardianai.v1.referral.GetSearchStrategiesRequest
 */
export type GetSearchStrategiesRequest = Message<"guardianai.v1.referral.GetSearchStrategiesRequest"> & {
  /**
   * @generated from field: optional string product_id = 1;
   */
  productId?: string;
};

/**
 * --- Strategies ---
 *
 * @generated from message guardianai.v1.referral.GetSearchStrategiesRequest
 */
export type GetSearchStrategiesRequestJson = {
  /**
   * @generated from field: optional string product_id = 1;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.referral.GetSearchStrategiesRequest.
 * Use `create(GetSearchStrategiesRequestSchema)` to create a new message.
 */
export const GetSearchStrategiesRequestSchema: GenMessage<GetSearchStrategiesRequest, {jsonType: GetSearchStrategiesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 49);

/**
 * @generated from message guardianai.v1.referral.GetSearchStrategiesResponse
 */
export type GetSearchStrategiesResponse = Message<"guardianai.v1.referral.GetSearchStrategiesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesSearchStrategy strategies = 1;
   */
  strategies: SalesSearchStrategy[];
};

/**
 * @generated from message guardianai.v1.referral.GetSearchStrategiesResponse
 */
export type GetSearchStrategiesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesSearchStrategy strategies = 1;
   */
  strategies?: SalesSearchStrategyJson[];
};

/**
 * Describes the message guardianai.v1.referral.GetSearchStrategiesResponse.
 * Use `create(GetSearchStrategiesResponseSchema)` to create a new message.
 */
export const GetSearchStrategiesResponseSchema: GenMessage<GetSearchStrategiesResponse, {jsonType: GetSearchStrategiesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 50);

/**
 * @generated from message guardianai.v1.referral.RegenerateSearchStrategiesRequest
 */
export type RegenerateSearchStrategiesRequest = Message<"guardianai.v1.referral.RegenerateSearchStrategiesRequest"> & {
  /**
   * @generated from field: string product_id = 1;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.referral.RegenerateSearchStrategiesRequest
 */
export type RegenerateSearchStrategiesRequestJson = {
  /**
   * @generated from field: string product_id = 1;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.referral.RegenerateSearchStrategiesRequest.
 * Use `create(RegenerateSearchStrategiesRequestSchema)` to create a new message.
 */
export const RegenerateSearchStrategiesRequestSchema: GenMessage<RegenerateSearchStrategiesRequest, {jsonType: RegenerateSearchStrategiesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 51);

/**
 * @generated from message guardianai.v1.referral.RegenerateSearchStrategiesResponse
 */
export type RegenerateSearchStrategiesResponse = Message<"guardianai.v1.referral.RegenerateSearchStrategiesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesSearchStrategy strategies = 1;
   */
  strategies: SalesSearchStrategy[];
};

/**
 * @generated from message guardianai.v1.referral.RegenerateSearchStrategiesResponse
 */
export type RegenerateSearchStrategiesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesSearchStrategy strategies = 1;
   */
  strategies?: SalesSearchStrategyJson[];
};

/**
 * Describes the message guardianai.v1.referral.RegenerateSearchStrategiesResponse.
 * Use `create(RegenerateSearchStrategiesResponseSchema)` to create a new message.
 */
export const RegenerateSearchStrategiesResponseSchema: GenMessage<RegenerateSearchStrategiesResponse, {jsonType: RegenerateSearchStrategiesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 52);

/**
 * @generated from message guardianai.v1.referral.GetMessageStrategyRequest
 */
export type GetMessageStrategyRequest = Message<"guardianai.v1.referral.GetMessageStrategyRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * @generated from message guardianai.v1.referral.GetMessageStrategyRequest
 */
export type GetMessageStrategyRequestJson = {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId?: string;
};

/**
 * Describes the message guardianai.v1.referral.GetMessageStrategyRequest.
 * Use `create(GetMessageStrategyRequestSchema)` to create a new message.
 */
export const GetMessageStrategyRequestSchema: GenMessage<GetMessageStrategyRequest, {jsonType: GetMessageStrategyRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 53);

/**
 * @generated from message guardianai.v1.referral.GetMessageStrategyResponse
 */
export type GetMessageStrategyResponse = Message<"guardianai.v1.referral.GetMessageStrategyResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesMessageStrategy strategy = 1;
   */
  strategy?: SalesMessageStrategy;
};

/**
 * @generated from message guardianai.v1.referral.GetMessageStrategyResponse
 */
export type GetMessageStrategyResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesMessageStrategy strategy = 1;
   */
  strategy?: SalesMessageStrategyJson;
};

/**
 * Describes the message guardianai.v1.referral.GetMessageStrategyResponse.
 * Use `create(GetMessageStrategyResponseSchema)` to create a new message.
 */
export const GetMessageStrategyResponseSchema: GenMessage<GetMessageStrategyResponse, {jsonType: GetMessageStrategyResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 54);

/**
 * --- CRM Leads ---
 *
 * @generated from message guardianai.v1.referral.CreateLeadRequest
 */
export type CreateLeadRequest = Message<"guardianai.v1.referral.CreateLeadRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesLead lead = 1;
   */
  lead?: SalesLead;
};

/**
 * --- CRM Leads ---
 *
 * @generated from message guardianai.v1.referral.CreateLeadRequest
 */
export type CreateLeadRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesLead lead = 1;
   */
  lead?: SalesLeadJson;
};

/**
 * Describes the message guardianai.v1.referral.CreateLeadRequest.
 * Use `create(CreateLeadRequestSchema)` to create a new message.
 */
export const CreateLeadRequestSchema: GenMessage<CreateLeadRequest, {jsonType: CreateLeadRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 55);

/**
 * @generated from message guardianai.v1.referral.UpdateLeadRequest
 */
export type UpdateLeadRequest = Message<"guardianai.v1.referral.UpdateLeadRequest"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesLead lead = 1;
   */
  lead?: SalesLead;
};

/**
 * @generated from message guardianai.v1.referral.UpdateLeadRequest
 */
export type UpdateLeadRequestJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesLead lead = 1;
   */
  lead?: SalesLeadJson;
};

/**
 * Describes the message guardianai.v1.referral.UpdateLeadRequest.
 * Use `create(UpdateLeadRequestSchema)` to create a new message.
 */
export const UpdateLeadRequestSchema: GenMessage<UpdateLeadRequest, {jsonType: UpdateLeadRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 56);

/**
 * @generated from message guardianai.v1.referral.DeleteLeadRequest
 */
export type DeleteLeadRequest = Message<"guardianai.v1.referral.DeleteLeadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.DeleteLeadRequest
 */
export type DeleteLeadRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.DeleteLeadRequest.
 * Use `create(DeleteLeadRequestSchema)` to create a new message.
 */
export const DeleteLeadRequestSchema: GenMessage<DeleteLeadRequest, {jsonType: DeleteLeadRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 57);

/**
 * @generated from message guardianai.v1.referral.DeleteLeadResponse
 */
export type DeleteLeadResponse = Message<"guardianai.v1.referral.DeleteLeadResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.DeleteLeadResponse
 */
export type DeleteLeadResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.DeleteLeadResponse.
 * Use `create(DeleteLeadResponseSchema)` to create a new message.
 */
export const DeleteLeadResponseSchema: GenMessage<DeleteLeadResponse, {jsonType: DeleteLeadResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 58);

/**
 * @generated from message guardianai.v1.referral.ListLeadsRequest
 */
export type ListLeadsRequest = Message<"guardianai.v1.referral.ListLeadsRequest"> & {
  /**
   * @generated from field: optional string product_id = 1;
   */
  productId?: string;

  /**
   * @generated from field: optional string platform = 2;
   */
  platform?: string;

  /**
   * @generated from field: optional string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 4;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.referral.ListLeadsRequest
 */
export type ListLeadsRequestJson = {
  /**
   * @generated from field: optional string product_id = 1;
   */
  productId?: string;

  /**
   * @generated from field: optional string platform = 2;
   */
  platform?: string;

  /**
   * @generated from field: optional string status = 3;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 4;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListLeadsRequest.
 * Use `create(ListLeadsRequestSchema)` to create a new message.
 */
export const ListLeadsRequestSchema: GenMessage<ListLeadsRequest, {jsonType: ListLeadsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 59);

/**
 * @generated from message guardianai.v1.referral.ListLeadsResponse
 */
export type ListLeadsResponse = Message<"guardianai.v1.referral.ListLeadsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesLead leads = 1;
   */
  leads: SalesLead[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.referral.ListLeadsResponse
 */
export type ListLeadsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesLead leads = 1;
   */
  leads?: SalesLeadJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListLeadsResponse.
 * Use `create(ListLeadsResponseSchema)` to create a new message.
 */
export const ListLeadsResponseSchema: GenMessage<ListLeadsResponse, {jsonType: ListLeadsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 60);

/**
 * @generated from message guardianai.v1.referral.GetLeadRequest
 */
export type GetLeadRequest = Message<"guardianai.v1.referral.GetLeadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.GetLeadRequest
 */
export type GetLeadRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.GetLeadRequest.
 * Use `create(GetLeadRequestSchema)` to create a new message.
 */
export const GetLeadRequestSchema: GenMessage<GetLeadRequest, {jsonType: GetLeadRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 61);

/**
 * @generated from message guardianai.v1.referral.UpdateLeadStatusRequest
 */
export type UpdateLeadStatusRequest = Message<"guardianai.v1.referral.UpdateLeadStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string new_status = 2;
   */
  newStatus: string;

  /**
   * @generated from field: optional string response_type = 3;
   */
  responseType?: string;
};

/**
 * @generated from message guardianai.v1.referral.UpdateLeadStatusRequest
 */
export type UpdateLeadStatusRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string new_status = 2;
   */
  newStatus?: string;

  /**
   * @generated from field: optional string response_type = 3;
   */
  responseType?: string;
};

/**
 * Describes the message guardianai.v1.referral.UpdateLeadStatusRequest.
 * Use `create(UpdateLeadStatusRequestSchema)` to create a new message.
 */
export const UpdateLeadStatusRequestSchema: GenMessage<UpdateLeadStatusRequest, {jsonType: UpdateLeadStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 62);

/**
 * @generated from message guardianai.v1.referral.LeadResponse
 */
export type LeadResponse = Message<"guardianai.v1.referral.LeadResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.SalesLead lead = 1;
   */
  lead?: SalesLead;
};

/**
 * @generated from message guardianai.v1.referral.LeadResponse
 */
export type LeadResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.SalesLead lead = 1;
   */
  lead?: SalesLeadJson;
};

/**
 * Describes the message guardianai.v1.referral.LeadResponse.
 * Use `create(LeadResponseSchema)` to create a new message.
 */
export const LeadResponseSchema: GenMessage<LeadResponse, {jsonType: LeadResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 63);

/**
 * --- Tasks ---
 *
 * @generated from message guardianai.v1.referral.GetLeadTableTasksRequest
 */
export type GetLeadTableTasksRequest = Message<"guardianai.v1.referral.GetLeadTableTasksRequest"> & {
};

/**
 * --- Tasks ---
 *
 * @generated from message guardianai.v1.referral.GetLeadTableTasksRequest
 */
export type GetLeadTableTasksRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.GetLeadTableTasksRequest.
 * Use `create(GetLeadTableTasksRequestSchema)` to create a new message.
 */
export const GetLeadTableTasksRequestSchema: GenMessage<GetLeadTableTasksRequest, {jsonType: GetLeadTableTasksRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 64);

/**
 * @generated from message guardianai.v1.referral.GetLeadTableTasksResponse
 */
export type GetLeadTableTasksResponse = Message<"guardianai.v1.referral.GetLeadTableTasksResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesLeadTableTask tasks = 1;
   */
  tasks: SalesLeadTableTask[];
};

/**
 * @generated from message guardianai.v1.referral.GetLeadTableTasksResponse
 */
export type GetLeadTableTasksResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesLeadTableTask tasks = 1;
   */
  tasks?: SalesLeadTableTaskJson[];
};

/**
 * Describes the message guardianai.v1.referral.GetLeadTableTasksResponse.
 * Use `create(GetLeadTableTasksResponseSchema)` to create a new message.
 */
export const GetLeadTableTasksResponseSchema: GenMessage<GetLeadTableTasksResponse, {jsonType: GetLeadTableTasksResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 65);

/**
 * @generated from message guardianai.v1.referral.SubmitForStrategyRequest
 */
export type SubmitForStrategyRequest = Message<"guardianai.v1.referral.SubmitForStrategyRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * @generated from message guardianai.v1.referral.SubmitForStrategyRequest
 */
export type SubmitForStrategyRequestJson = {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId?: string;
};

/**
 * Describes the message guardianai.v1.referral.SubmitForStrategyRequest.
 * Use `create(SubmitForStrategyRequestSchema)` to create a new message.
 */
export const SubmitForStrategyRequestSchema: GenMessage<SubmitForStrategyRequest, {jsonType: SubmitForStrategyRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 66);

/**
 * @generated from message guardianai.v1.referral.SubmitForStrategyResponse
 */
export type SubmitForStrategyResponse = Message<"guardianai.v1.referral.SubmitForStrategyResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.SubmitForStrategyResponse
 */
export type SubmitForStrategyResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.SubmitForStrategyResponse.
 * Use `create(SubmitForStrategyResponseSchema)` to create a new message.
 */
export const SubmitForStrategyResponseSchema: GenMessage<SubmitForStrategyResponse, {jsonType: SubmitForStrategyResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 67);

/**
 * --- Notifications ---
 *
 * @generated from message guardianai.v1.referral.GetSalesNotificationsRequest
 */
export type GetSalesNotificationsRequest = Message<"guardianai.v1.referral.GetSalesNotificationsRequest"> & {
  /**
   * @generated from field: bool unread_only = 1;
   */
  unreadOnly: boolean;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * --- Notifications ---
 *
 * @generated from message guardianai.v1.referral.GetSalesNotificationsRequest
 */
export type GetSalesNotificationsRequestJson = {
  /**
   * @generated from field: bool unread_only = 1;
   */
  unreadOnly?: boolean;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.GetSalesNotificationsRequest.
 * Use `create(GetSalesNotificationsRequestSchema)` to create a new message.
 */
export const GetSalesNotificationsRequestSchema: GenMessage<GetSalesNotificationsRequest, {jsonType: GetSalesNotificationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 68);

/**
 * @generated from message guardianai.v1.referral.GetSalesNotificationsResponse
 */
export type GetSalesNotificationsResponse = Message<"guardianai.v1.referral.GetSalesNotificationsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesNotification notifications = 1;
   */
  notifications: SalesNotification[];
};

/**
 * @generated from message guardianai.v1.referral.GetSalesNotificationsResponse
 */
export type GetSalesNotificationsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.SalesNotification notifications = 1;
   */
  notifications?: SalesNotificationJson[];
};

/**
 * Describes the message guardianai.v1.referral.GetSalesNotificationsResponse.
 * Use `create(GetSalesNotificationsResponseSchema)` to create a new message.
 */
export const GetSalesNotificationsResponseSchema: GenMessage<GetSalesNotificationsResponse, {jsonType: GetSalesNotificationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 69);

/**
 * @generated from message guardianai.v1.referral.MarkSalesNotificationReadRequest
 */
export type MarkSalesNotificationReadRequest = Message<"guardianai.v1.referral.MarkSalesNotificationReadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * @generated from message guardianai.v1.referral.MarkSalesNotificationReadRequest
 */
export type MarkSalesNotificationReadRequestJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;
};

/**
 * Describes the message guardianai.v1.referral.MarkSalesNotificationReadRequest.
 * Use `create(MarkSalesNotificationReadRequestSchema)` to create a new message.
 */
export const MarkSalesNotificationReadRequestSchema: GenMessage<MarkSalesNotificationReadRequest, {jsonType: MarkSalesNotificationReadRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 70);

/**
 * @generated from message guardianai.v1.referral.MarkSalesNotificationReadResponse
 */
export type MarkSalesNotificationReadResponse = Message<"guardianai.v1.referral.MarkSalesNotificationReadResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.MarkSalesNotificationReadResponse
 */
export type MarkSalesNotificationReadResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.MarkSalesNotificationReadResponse.
 * Use `create(MarkSalesNotificationReadResponseSchema)` to create a new message.
 */
export const MarkSalesNotificationReadResponseSchema: GenMessage<MarkSalesNotificationReadResponse, {jsonType: MarkSalesNotificationReadResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 71);

/**
 * --- Dashboard & Attributions ---
 *
 * @generated from message guardianai.v1.referral.ListMyReferralLinksRequest
 */
export type ListMyReferralLinksRequest = Message<"guardianai.v1.referral.ListMyReferralLinksRequest"> & {
};

/**
 * --- Dashboard & Attributions ---
 *
 * @generated from message guardianai.v1.referral.ListMyReferralLinksRequest
 */
export type ListMyReferralLinksRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.ListMyReferralLinksRequest.
 * Use `create(ListMyReferralLinksRequestSchema)` to create a new message.
 */
export const ListMyReferralLinksRequestSchema: GenMessage<ListMyReferralLinksRequest, {jsonType: ListMyReferralLinksRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 72);

/**
 * @generated from message guardianai.v1.referral.ListMyReferralLinksResponse
 */
export type ListMyReferralLinksResponse = Message<"guardianai.v1.referral.ListMyReferralLinksResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralLink links = 1;
   */
  links: ReferralLink[];
};

/**
 * @generated from message guardianai.v1.referral.ListMyReferralLinksResponse
 */
export type ListMyReferralLinksResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralLink links = 1;
   */
  links?: ReferralLinkJson[];
};

/**
 * Describes the message guardianai.v1.referral.ListMyReferralLinksResponse.
 * Use `create(ListMyReferralLinksResponseSchema)` to create a new message.
 */
export const ListMyReferralLinksResponseSchema: GenMessage<ListMyReferralLinksResponse, {jsonType: ListMyReferralLinksResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 73);

/**
 * @generated from message guardianai.v1.referral.GetReferralLinkStatsRequest
 */
export type GetReferralLinkStatsRequest = Message<"guardianai.v1.referral.GetReferralLinkStatsRequest"> & {
  /**
   * @generated from field: string product_id = 1;
   */
  productId: string;
};

/**
 * @generated from message guardianai.v1.referral.GetReferralLinkStatsRequest
 */
export type GetReferralLinkStatsRequestJson = {
  /**
   * @generated from field: string product_id = 1;
   */
  productId?: string;
};

/**
 * Describes the message guardianai.v1.referral.GetReferralLinkStatsRequest.
 * Use `create(GetReferralLinkStatsRequestSchema)` to create a new message.
 */
export const GetReferralLinkStatsRequestSchema: GenMessage<GetReferralLinkStatsRequest, {jsonType: GetReferralLinkStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 74);

/**
 * @generated from message guardianai.v1.referral.ReferralLinkStatsResponse
 */
export type ReferralLinkStatsResponse = Message<"guardianai.v1.referral.ReferralLinkStatsResponse"> & {
  /**
   * @generated from field: guardianai.v1.referral.ReferralLink link = 1;
   */
  link?: ReferralLink;

  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralAttribution recent_conversions = 2;
   */
  recentConversions: ReferralAttribution[];
};

/**
 * @generated from message guardianai.v1.referral.ReferralLinkStatsResponse
 */
export type ReferralLinkStatsResponseJson = {
  /**
   * @generated from field: guardianai.v1.referral.ReferralLink link = 1;
   */
  link?: ReferralLinkJson;

  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralAttribution recent_conversions = 2;
   */
  recentConversions?: ReferralAttributionJson[];
};

/**
 * Describes the message guardianai.v1.referral.ReferralLinkStatsResponse.
 * Use `create(ReferralLinkStatsResponseSchema)` to create a new message.
 */
export const ReferralLinkStatsResponseSchema: GenMessage<ReferralLinkStatsResponse, {jsonType: ReferralLinkStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 75);

/**
 * @generated from message guardianai.v1.referral.CreateAttributionRequest
 */
export type CreateAttributionRequest = Message<"guardianai.v1.referral.CreateAttributionRequest"> & {
  /**
   * @generated from field: string sales_lead_id = 1;
   */
  salesLeadId: string;

  /**
   * @generated from field: string product_id = 2;
   */
  productId: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * @generated from field: optional string customer_email = 4;
   */
  customerEmail?: string;

  /**
   * @generated from field: optional string customer_company = 5;
   */
  customerCompany?: string;
};

/**
 * @generated from message guardianai.v1.referral.CreateAttributionRequest
 */
export type CreateAttributionRequestJson = {
  /**
   * @generated from field: string sales_lead_id = 1;
   */
  salesLeadId?: string;

  /**
   * @generated from field: string product_id = 2;
   */
  productId?: string;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName?: string;

  /**
   * @generated from field: optional string customer_email = 4;
   */
  customerEmail?: string;

  /**
   * @generated from field: optional string customer_company = 5;
   */
  customerCompany?: string;
};

/**
 * Describes the message guardianai.v1.referral.CreateAttributionRequest.
 * Use `create(CreateAttributionRequestSchema)` to create a new message.
 */
export const CreateAttributionRequestSchema: GenMessage<CreateAttributionRequest, {jsonType: CreateAttributionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 76);

/**
 * @generated from message guardianai.v1.referral.ListMyAttributionsRequest
 */
export type ListMyAttributionsRequest = Message<"guardianai.v1.referral.ListMyAttributionsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.referral.ListMyAttributionsRequest
 */
export type ListMyAttributionsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListMyAttributionsRequest.
 * Use `create(ListMyAttributionsRequestSchema)` to create a new message.
 */
export const ListMyAttributionsRequestSchema: GenMessage<ListMyAttributionsRequest, {jsonType: ListMyAttributionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 77);

/**
 * @generated from message guardianai.v1.referral.ListMyAttributionsResponse
 */
export type ListMyAttributionsResponse = Message<"guardianai.v1.referral.ListMyAttributionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralAttribution attributions = 1;
   */
  attributions: ReferralAttribution[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.referral.ListMyAttributionsResponse
 */
export type ListMyAttributionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.referral.ReferralAttribution attributions = 1;
   */
  attributions?: ReferralAttributionJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.referral.ListMyAttributionsResponse.
 * Use `create(ListMyAttributionsResponseSchema)` to create a new message.
 */
export const ListMyAttributionsResponseSchema: GenMessage<ListMyAttributionsResponse, {jsonType: ListMyAttributionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 78);

/**
 * @generated from message guardianai.v1.referral.GetAgentDashboardRequest
 */
export type GetAgentDashboardRequest = Message<"guardianai.v1.referral.GetAgentDashboardRequest"> & {
};

/**
 * @generated from message guardianai.v1.referral.GetAgentDashboardRequest
 */
export type GetAgentDashboardRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.GetAgentDashboardRequest.
 * Use `create(GetAgentDashboardRequestSchema)` to create a new message.
 */
export const GetAgentDashboardRequestSchema: GenMessage<GetAgentDashboardRequest, {jsonType: GetAgentDashboardRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 79);

/**
 * @generated from message guardianai.v1.referral.AgentDashboardResponse
 */
export type AgentDashboardResponse = Message<"guardianai.v1.referral.AgentDashboardResponse"> & {
  /**
   * @generated from field: int32 assigned_products_count = 1;
   */
  assignedProductsCount: number;

  /**
   * @generated from field: int32 total_leads = 2;
   */
  totalLeads: number;

  /**
   * @generated from field: int32 due_follow_ups = 3;
   */
  dueFollowUps: number;

  /**
   * @generated from field: int32 closed_deals = 4;
   */
  closedDeals: number;

  /**
   * @generated from field: int64 total_earnings_cents = 5;
   */
  totalEarningsCents: bigint;

  /**
   * @generated from field: int64 pending_earnings_cents = 6;
   */
  pendingEarningsCents: bigint;

  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent = 7;
   */
  agent?: SalesAgent;
};

/**
 * @generated from message guardianai.v1.referral.AgentDashboardResponse
 */
export type AgentDashboardResponseJson = {
  /**
   * @generated from field: int32 assigned_products_count = 1;
   */
  assignedProductsCount?: number;

  /**
   * @generated from field: int32 total_leads = 2;
   */
  totalLeads?: number;

  /**
   * @generated from field: int32 due_follow_ups = 3;
   */
  dueFollowUps?: number;

  /**
   * @generated from field: int32 closed_deals = 4;
   */
  closedDeals?: number;

  /**
   * @generated from field: int64 total_earnings_cents = 5;
   */
  totalEarningsCents?: string;

  /**
   * @generated from field: int64 pending_earnings_cents = 6;
   */
  pendingEarningsCents?: string;

  /**
   * @generated from field: guardianai.v1.referral.SalesAgent agent = 7;
   */
  agent?: SalesAgentJson;
};

/**
 * Describes the message guardianai.v1.referral.AgentDashboardResponse.
 * Use `create(AgentDashboardResponseSchema)` to create a new message.
 */
export const AgentDashboardResponseSchema: GenMessage<AgentDashboardResponse, {jsonType: AgentDashboardResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 80);

/**
 * @generated from message guardianai.v1.referral.ApplyAsAgentRequest
 */
export type ApplyAsAgentRequest = Message<"guardianai.v1.referral.ApplyAsAgentRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * @generated from message guardianai.v1.referral.ApplyAsAgentRequest
 */
export type ApplyAsAgentRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;
};

/**
 * Describes the message guardianai.v1.referral.ApplyAsAgentRequest.
 * Use `create(ApplyAsAgentRequestSchema)` to create a new message.
 */
export const ApplyAsAgentRequestSchema: GenMessage<ApplyAsAgentRequest, {jsonType: ApplyAsAgentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 81);

/**
 * @generated from message guardianai.v1.referral.ApplyAsAgentResponse
 */
export type ApplyAsAgentResponse = Message<"guardianai.v1.referral.ApplyAsAgentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.referral.ApplyAsAgentResponse
 */
export type ApplyAsAgentResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.referral.ApplyAsAgentResponse.
 * Use `create(ApplyAsAgentResponseSchema)` to create a new message.
 */
export const ApplyAsAgentResponseSchema: GenMessage<ApplyAsAgentResponse, {jsonType: ApplyAsAgentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 82);

/**
 * Onboarding config (public read - for sales onboarding wizard video)
 *
 * @generated from message guardianai.v1.referral.GetPublicOnboardingConfigRequest
 */
export type GetPublicOnboardingConfigRequest = Message<"guardianai.v1.referral.GetPublicOnboardingConfigRequest"> & {
};

/**
 * Onboarding config (public read - for sales onboarding wizard video)
 *
 * @generated from message guardianai.v1.referral.GetPublicOnboardingConfigRequest
 */
export type GetPublicOnboardingConfigRequestJson = {
};

/**
 * Describes the message guardianai.v1.referral.GetPublicOnboardingConfigRequest.
 * Use `create(GetPublicOnboardingConfigRequestSchema)` to create a new message.
 */
export const GetPublicOnboardingConfigRequestSchema: GenMessage<GetPublicOnboardingConfigRequest, {jsonType: GetPublicOnboardingConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_referral_referral_sales, 83);

/**
 * @generated from service guardianai.v1.referral.AdminReferralSalesService
 */
export const AdminReferralSalesService: GenService<{
  /**
   * Products
   *
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.CreateProduct
   */
  createProduct: {
    methodKind: "unary";
    input: typeof CreateProductRequestSchema;
    output: typeof ProductResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.UpdateProduct
   */
  updateProduct: {
    methodKind: "unary";
    input: typeof UpdateProductRequestSchema;
    output: typeof ProductResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.DeleteProduct
   */
  deleteProduct: {
    methodKind: "unary";
    input: typeof DeleteProductRequestSchema;
    output: typeof DeleteProductResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.ListProducts
   */
  listProducts: {
    methodKind: "unary";
    input: typeof ListProductsRequestSchema;
    output: typeof ListProductsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.GetProduct
   */
  getProduct: {
    methodKind: "unary";
    input: typeof GetProductRequestSchema;
    output: typeof ProductResponseSchema;
  },
  /**
   * Agents
   *
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.InviteSalesAgent
   */
  inviteSalesAgent: {
    methodKind: "unary";
    input: typeof InviteSalesAgentRequestSchema;
    output: typeof InviteSalesAgentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.ListSalesAgents
   */
  listSalesAgents: {
    methodKind: "unary";
    input: typeof ListSalesAgentsRequestSchema;
    output: typeof ListSalesAgentsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.GetSalesAgent
   */
  getSalesAgent: {
    methodKind: "unary";
    input: typeof GetSalesAgentRequestSchema;
    output: typeof SalesAgentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.ApproveSalesAgent
   */
  approveSalesAgent: {
    methodKind: "unary";
    input: typeof ApproveSalesAgentRequestSchema;
    output: typeof SalesAgentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.SuspendSalesAgent
   */
  suspendSalesAgent: {
    methodKind: "unary";
    input: typeof SuspendSalesAgentRequestSchema;
    output: typeof SalesAgentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.UpdateAgentProductAuth
   */
  updateAgentProductAuth: {
    methodKind: "unary";
    input: typeof UpdateAgentProductAuthRequestSchema;
    output: typeof SalesAgentResponseSchema;
  },
  /**
   * Attributions
   *
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.ListAttributions
   */
  listAttributions: {
    methodKind: "unary";
    input: typeof ListAttributionsRequestSchema;
    output: typeof ListAttributionsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.VerifyAttribution
   */
  verifyAttribution: {
    methodKind: "unary";
    input: typeof VerifyAttributionRequestSchema;
    output: typeof AttributionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.RejectAttribution
   */
  rejectAttribution: {
    methodKind: "unary";
    input: typeof RejectAttributionRequestSchema;
    output: typeof AttributionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.MarkAttributionPaid
   */
  markAttributionPaid: {
    methodKind: "unary";
    input: typeof MarkAttributionPaidRequestSchema;
    output: typeof AttributionResponseSchema;
  },
  /**
   * Dashboard
   *
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.GetReferralDashboardStats
   */
  getReferralDashboardStats: {
    methodKind: "unary";
    input: typeof GetReferralDashboardStatsRequestSchema;
    output: typeof ReferralDashboardStatsResponseSchema;
  },
  /**
   * Configuration
   *
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.GetSalesOnboardingConfig
   */
  getSalesOnboardingConfig: {
    methodKind: "unary";
    input: typeof GetSalesOnboardingConfigRequestSchema;
    output: typeof SalesOnboardingConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.UpdateSalesOnboardingConfig
   */
  updateSalesOnboardingConfig: {
    methodKind: "unary";
    input: typeof UpdateSalesOnboardingConfigRequestSchema;
    output: typeof SalesOnboardingConfigResponseSchema;
  },
  /**
   * Product Catalog
   *
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.ListProductCatalog
   */
  listProductCatalog: {
    methodKind: "unary";
    input: typeof ListProductCatalogRequestSchema;
    output: typeof ListProductCatalogResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.CreateProductCatalogEntry
   */
  createProductCatalogEntry: {
    methodKind: "unary";
    input: typeof CreateProductCatalogRequestSchema;
    output: typeof ProductCatalogEntrySchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.UpdateProductCatalogEntry
   */
  updateProductCatalogEntry: {
    methodKind: "unary";
    input: typeof UpdateProductCatalogRequestSchema;
    output: typeof ProductCatalogEntrySchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.AdminReferralSalesService.DeleteProductCatalogEntry
   */
  deleteProductCatalogEntry: {
    methodKind: "unary";
    input: typeof DeleteProductCatalogRequestSchema;
    output: typeof DeleteProductCatalogResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_referral_referral_sales, 0);

/**
 * @generated from service guardianai.v1.referral.SalesAgentService
 */
export const SalesAgentService: GenService<{
  /**
   * Onboarding
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetOnboardingProfile
   */
  getOnboardingProfile: {
    methodKind: "unary";
    input: typeof GetOnboardingProfileRequestSchema;
    output: typeof OnboardingProfileResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.SubmitOnboardingProfile
   */
  submitOnboardingProfile: {
    methodKind: "unary";
    input: typeof SubmitOnboardingProfileRequestSchema;
    output: typeof SubmitOnboardingProfileResponseSchema;
  },
  /**
   * Search strategies
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetSearchStrategies
   */
  getSearchStrategies: {
    methodKind: "unary";
    input: typeof GetSearchStrategiesRequestSchema;
    output: typeof GetSearchStrategiesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.RegenerateSearchStrategies
   */
  regenerateSearchStrategies: {
    methodKind: "unary";
    input: typeof RegenerateSearchStrategiesRequestSchema;
    output: typeof RegenerateSearchStrategiesResponseSchema;
  },
  /**
   * CRM
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.CreateLead
   */
  createLead: {
    methodKind: "unary";
    input: typeof CreateLeadRequestSchema;
    output: typeof LeadResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.UpdateLead
   */
  updateLead: {
    methodKind: "unary";
    input: typeof UpdateLeadRequestSchema;
    output: typeof LeadResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.DeleteLead
   */
  deleteLead: {
    methodKind: "unary";
    input: typeof DeleteLeadRequestSchema;
    output: typeof DeleteLeadResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.ListLeads
   */
  listLeads: {
    methodKind: "unary";
    input: typeof ListLeadsRequestSchema;
    output: typeof ListLeadsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetLead
   */
  getLead: {
    methodKind: "unary";
    input: typeof GetLeadRequestSchema;
    output: typeof LeadResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.UpdateLeadStatus
   */
  updateLeadStatus: {
    methodKind: "unary";
    input: typeof UpdateLeadStatusRequestSchema;
    output: typeof LeadResponseSchema;
  },
  /**
   * Tasks & Messages
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetLeadTableTasks
   */
  getLeadTableTasks: {
    methodKind: "unary";
    input: typeof GetLeadTableTasksRequestSchema;
    output: typeof GetLeadTableTasksResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.SubmitForStrategy
   */
  submitForStrategy: {
    methodKind: "unary";
    input: typeof SubmitForStrategyRequestSchema;
    output: typeof SubmitForStrategyResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetMessageStrategy
   */
  getMessageStrategy: {
    methodKind: "unary";
    input: typeof GetMessageStrategyRequestSchema;
    output: typeof GetMessageStrategyResponseSchema;
  },
  /**
   * Notifications
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetNotifications
   */
  getNotifications: {
    methodKind: "unary";
    input: typeof GetSalesNotificationsRequestSchema;
    output: typeof GetSalesNotificationsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.MarkNotificationRead
   */
  markNotificationRead: {
    methodKind: "unary";
    input: typeof MarkSalesNotificationReadRequestSchema;
    output: typeof MarkSalesNotificationReadResponseSchema;
  },
  /**
   * Attributions & Links (Self-serve)
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.ListMyReferralLinks
   */
  listMyReferralLinks: {
    methodKind: "unary";
    input: typeof ListMyReferralLinksRequestSchema;
    output: typeof ListMyReferralLinksResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetReferralLinkStats
   */
  getReferralLinkStats: {
    methodKind: "unary";
    input: typeof GetReferralLinkStatsRequestSchema;
    output: typeof ReferralLinkStatsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.CreateAttribution
   */
  createAttribution: {
    methodKind: "unary";
    input: typeof CreateAttributionRequestSchema;
    output: typeof AttributionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.referral.SalesAgentService.ListMyAttributions
   */
  listMyAttributions: {
    methodKind: "unary";
    input: typeof ListMyAttributionsRequestSchema;
    output: typeof ListMyAttributionsResponseSchema;
  },
  /**
   * Dashboard
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetAgentDashboard
   */
  getAgentDashboard: {
    methodKind: "unary";
    input: typeof GetAgentDashboardRequestSchema;
    output: typeof AgentDashboardResponseSchema;
  },
  /**
   * Configuration
   *
   * @generated from rpc guardianai.v1.referral.SalesAgentService.GetOnboardingConfig
   */
  getOnboardingConfig: {
    methodKind: "unary";
    input: typeof GetSalesOnboardingConfigRequestSchema;
    output: typeof SalesOnboardingConfigResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_referral_referral_sales, 1);

/**
 * @generated from service guardianai.v1.referral.PublicReferralService
 */
export const PublicReferralService: GenService<{
  /**
   * Self-service application for prospective sales agents (public, no auth)
   *
   * @generated from rpc guardianai.v1.referral.PublicReferralService.ApplyAsAgent
   */
  applyAsAgent: {
    methodKind: "unary";
    input: typeof ApplyAsAgentRequestSchema;
    output: typeof ApplyAsAgentResponseSchema;
  },
  /**
   * Public read of onboarding config (e.g. YouTube video URL)
   *
   * @generated from rpc guardianai.v1.referral.PublicReferralService.GetPublicOnboardingConfig
   */
  getPublicOnboardingConfig: {
    methodKind: "unary";
    input: typeof GetPublicOnboardingConfigRequestSchema;
    output: typeof SalesOnboardingConfigResponseSchema;
  },
  /**
   * Public Product Catalog
   *
   * @generated from rpc guardianai.v1.referral.PublicReferralService.ListProductCatalog
   */
  listProductCatalog: {
    methodKind: "unary";
    input: typeof ListProductCatalogRequestSchema;
    output: typeof ListProductCatalogResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_referral_referral_sales, 2);

